/**
 * मराठी — everyday polite register, society vocabulary as spoken in Maharashtra
 * (गेट/पास/डिलीव्हरी transliterations stay). DRAFTED BY LLM — needs
 * native-speaker review before public launch (I18N_PLAN).
 */
import type { Dict } from './en';

export const mr: Dict = {
  cancel: 'रद्द करा',
  retry: 'पुन्हा प्रयत्न करा',
  back_to_home: 'होमवर परत जा',

  tab_home: 'होम',
  tab_community: 'कम्युनिटी',
  tab_gate: 'गेट',
  tab_pay: 'पेमेंट',

  greeting_morning: 'सुप्रभात',
  greeting_afternoon: 'नमस्कार',
  greeting_evening: 'शुभ संध्याकाळ',
  urgent_notice: 'महत्त्वाची सूचना',
  acknowledge: 'वाचले',
  visitor_at_gate: 'गेटवर पाहुणे',
  delivery_waiting: 'एक डिलीव्हरी तुमच्या मंजुरीची वाट पाहत आहे. पाहण्यासाठी टॅप करा.',
  quick_actions: 'झटपट कामे',
  qa_visitor: 'पाहुणे',
  qa_helpdesk: 'हेल्पडेस्क',
  qa_pay: 'पेमेंट',
  qa_book: 'बुकिंग',
  qa_preapprove: 'प्री-अप्रूव्ह',
  qa_book_amenity: 'हॉल बुक करा',
  recent_activity: 'अलीकडील घडामोडी',
  nothing_new: 'सध्या काही नवीन नाही.',
  couldnt_load_notices: 'सूचना आत्ता लोड होऊ शकल्या नाहीत.',
  all_services: 'सर्व सेवा',
  grp_gate_visitors: 'गेट आणि पाहुणे',
  grp_staff_home: 'घरचा स्टाफ',
  grp_bookings: 'बुकिंग',
  grp_society: 'सोसायटी',
  svc_gate_pass: 'गेट पास',
  svc_parcels: 'पार्सल',
  svc_vehicles: 'गाड्या',
  svc_family: 'कुटुंब',
  svc_kids: 'मुले',
  svc_move: 'शिफ्टिंग',
  svc_my_staff: 'माझा स्टाफ',
  svc_attendance: 'हजेरी',
  svc_venues: 'हॉल बुकिंग',
  svc_my_bookings: 'माझ्या बुकिंग',
  svc_finances: 'हिशेब',
  svc_documents: 'कागदपत्रे',
  svc_directory: 'डिरेक्टरी',
  svc_sos: 'SOS',
  push_primer_title: 'गेटवर कोणी आले की लगेच कळेल',
  push_primer_body: 'पाहुणे, महत्त्वाच्या सूचना, गेस्ट पास — सगळे लगेच.',
  push_primer_cta: 'अलर्ट सुरू करा',
  push_primer_later: 'नंतर',

  main_gate_now: 'मुख्य गेट · आत्ता',
  close_wo_deciding: 'निर्णय न घेता बंद करा',
  for_flat: '{purpose} · फ्लॅट {flat} साठी',
  photo_taken: 'गेटवर फोटो घेतला',
  logged_by: 'नोंद केली',
  gate_desk: 'गेट डेस्क',
  arrived_at: 'येण्याची वेळ',
  id_checked: 'ID तपासले',
  auto_deny_in: 'आपोआप नकार',
  allow_in: 'आत येऊ द्या',
  allowed_notified: 'परवानगी दिली — गार्डला कळवले',
  leave_at_gate: 'गेटवर ठेवा',
  kept_at_gate: 'गेटवर ठेवले',
  deny: 'नकार द्या',
  denied: 'नकार दिला',
  decide_error: 'तुमचा निर्णय पाठवता आला नाही. इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  no_one_waiting: 'गेटवर कोणी वाट पाहत नाही',
  no_one_waiting_body: 'तुमच्या फ्लॅटसाठी कोणी आले की त्याची मंजुरी इथे दिसेल.',
  couldnt_load_visitors: 'पाहुण्यांची यादी उघडली नाही',
  couldnt_load_visitors_body: 'आत्ता यादी मिळत नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',

  emergency: 'इमर्जन्सी',
  sos_alert: 'SOS अलर्ट',
  sos_hold_instruction: 'सुरक्षा आणि कमिटीला इमर्जन्सी अलर्ट पाठवण्यासाठी खालचे बटण दाबून धरा.',
  hold: 'दाबून धरा',
  call_112: '112 ला कॉल करा',
  sos_when_send: 'SOS पाठवल्यावर:',
  sos_send_guards: 'सर्व गार्डना लगेच अलर्ट जाईल',
  sos_send_committee: 'कमिटीला कळवले जाईल',
  sos_send_contact: 'तुमच्या इमर्जन्सी नंबरवर कॉल जाईल',
  sos_send_flatinfo: 'मदतीला येणाऱ्यांना तुमच्या फ्लॅटची माहिती दिली जाईल',
  quick_dial: 'लगेच कॉल',
  sos_sent: 'SOS पाठवले',
  sos_on_way: 'सुरक्षा टीम येत आहे.',
  cancel_sos: 'SOS रद्द करा',
  sos_error: 'SOS पाठवता आले नाही. पुन्हा प्रयत्न करा किंवा थेट गेटला कॉल करा.',
  sos_type_medical: 'मेडिकल',
  sos_type_fire: 'आग',
  sos_type_security: 'सुरक्षा',
  sos_type_other: 'इतर',

  login_tagline: 'तुमच्या सोसायटीचे प्रत्येक गेट, एक शांत ॲप.',
  sign_in: 'साइन इन करा',
  login_sub: 'सोसायटीत नोंद असलेला ईमेल वापरा.',
  email: 'ईमेल',
  password: 'पासवर्ड',
  enter_password: 'पासवर्ड टाका',
  show: 'दाखवा',
  hide: 'लपवा',
  forgot_password: 'पासवर्ड विसरलात?',
  or: 'किंवा',
  new_to_bero: 'Bero वर नवीन आहात?',
  create_account: 'खाते तयार करा',

  main_gate: 'मुख्य गेट',
  on_duty: 'ड्युटीवर',
  sign_out: 'साइन आउट',
  stat_inside: 'आत',
  stat_awaiting: 'प्रतीक्षेत',
  stat_today: 'आज',
  new_entry: 'नवीन एंट्री',
  kiosk_visitor: 'पाहुणे',
  kiosk_visitor_sub: 'थेट आलेली व्यक्ती',
  kiosk_delivery: 'डिलीव्हरी',
  kiosk_delivery_sub: 'गेटवर कुरिअर',
  kiosk_cab: 'कॅब / ड्रायव्हर',
  kiosk_cab_sub: 'न्यायला किंवा सोडायला',
  gate_desk_hdr: 'गेट डेस्क',
  validate_pass: 'पास तपासा',
  validate_pass_sub: 'पाहुण्याचा PIN',
  staff_punch: 'स्टाफ हजेरी',
  staff_punch_sub: 'गेट कोड इन/आउट',
  todays_log: 'आजची नोंद',
  todays_log_sub: 'सर्व एंट्री',
  incident: 'घटना',
  incident_sub: 'ऑफिसला कळवा',
  messages: 'निरोप',
  kid_exits: 'मुलांचे बाहेर जाणे',
  no_entries_today: 'आज अजून एंट्री नाही.',
  mark_entered: 'आत आले',
  mark_left: 'बाहेर गेले',

  who_at_gate: 'गेटवर कोण आहे?',
  type_visitor: 'पाहुणे',
  type_delivery: 'डिलीव्हरी',
  type_cab: 'कॅब',
  company: 'कंपनी',
  cab_service: 'कॅब सर्व्हिस',
  person_name_opt: 'नाव (आवश्यक नाही)',
  name_lbl: 'नाव',
  full_name: 'पूर्ण नाव',
  flat_lbl: 'फ्लॅट',
  type_or_pick: 'टाइप करा किंवा खालून निवडा',
  wing_chip: 'विंग {code}',
  phone_opt: 'फोन (आवश्यक नाही)',
  vehicle_number: 'गाडी नंबर',
  visitor_photo: 'पाहुण्याचा फोटो',
  take_photo: 'फोटो घ्या',
  add_photo: 'फोटो जोडा',
  retake_photo: 'फोटो पुन्हा घ्या',
  companions: 'सोबतचे लोक (+N)',
  leave_at_gate_lbl: 'गेटवर ठेवा',
  leave_at_gate_sub: 'रहिवाशांना न विचारता पार्सलची नोंद करा.',
  ask_resident: 'रहिवाशांची मंजुरी घ्या',
  log_parcel: 'पार्सल गेटवर नोंदवा',
  err_flat_not_found: 'फ्लॅट सापडला नाही — फ्लॅट कोड तपासा.',
  err_fill_name: 'नाव (किंवा कंपनी) आणि फ्लॅट कोड भरा.',
  err_entry_generic: 'एंट्री नोंदवता आली नाही. पुन्हा प्रयत्न करा.',
  err_camera: 'कॅमेरा उघडला नाही.',

  alerts_title: 'नोटिफिकेशन सुरू करा',
  alerts_sub: 'यांच्याशिवाय Bero काम करू शकत नाही. गेटवरून तुमच्यापर्यंत निरोप यानेच पोहोचतो.',
  alerts_r1_title: 'गेटवर पाहुणे',
  alerts_r1_body: 'पाहुणे, डिलीव्हरी आणि कॅबला काही सेकंदांत मंजुरी द्या — उत्तर येईपर्यंत ते गेटवर थांबतात.',
  alerts_r2_title: 'पार्सल आणि पास',
  alerts_r2_body: 'पार्सल गेटवर आले किंवा पाहुणे आत आले — लगेच कळेल.',
  alerts_r3_title: 'महत्त्वाच्या सोसायटी सूचना',
  alerts_r3_body: 'पाणी बंद, वीज बंद, इमर्जन्सी — कमिटीने टाकताच तुमच्यापर्यंत.',
  alerts_r4_title: 'कुटुंबाचा SOS',
  alerts_r4_body: 'घरातल्या कोणी SOS दाबला तर तुम्हाला लगेच कळेल.',
  alerts_cta: 'नोटिफिकेशन सुरू करा',
  alerts_cta_settings: 'सेटिंग्जमधून परवानगी द्या',
  alerts_settings_hint: 'फोनच्या सेटिंग्जमध्ये Bero चे नोटिफिकेशन सध्या बंद आहेत.',
  alerts_skip: 'आत्ता नाही',

  // shared across guard screens
  allow_entry: 'आत येऊ द्या',
  back_to_gate: 'गेटवर परत',
  filter_all: 'सर्व',
  filter_approved: 'मंजूर',
  filter_rejected: 'नकार दिला',
  filter_awaiting: 'प्रतीक्षेत',

  // guard — validate pass
  validate_scan_qr: 'QR कोड स्कॅन करा',
  validate_aim_qr: 'पासच्या QR वर कॅमेरा धरा',
  validate_cam_off: 'कॅमेराची परवानगी बंद आहे — सेटिंग्जमध्ये सुरू करा, किंवा खाली PIN टाका.',
  validate_pin_label_or: 'किंवा पाहुण्याचा 6 अंकी PIN टाका',
  validate_pin_label: 'पाहुण्याचा 6 अंकी PIN',
  validate_pin_help: 'त्यांच्या पासवर, QR च्या खाली.',
  validate_check: 'पास तपासा',
  validate_not_found: 'या कोडचा कोणताही पास सापडला नाही.',
  validate_check_error: 'कोड तपासता आला नाही. पुन्हा प्रयत्न करा.',
  validate_entered_logged: 'आत आले — नोंद झाली',
  validate_daily_window: 'रोजची वेळ: {window}',

  // guard — waiting for resident
  waiting_title: 'रहिवाशांची वाट',
  waiting_buzzing: 'रहिवाशांचा फोन वाजत आहे…',
  waiting_sent_ago: '{n} सेकंदांपूर्वी पाठवले',
  waiting_approved: 'रहिवाशांनी मंजुरी दिली',
  waiting_rejected: 'नकार दिला — आत येऊ देऊ नका',
  waiting_left_at_gate: 'गेटवर ठेवले — रहिवाशांनी आत येऊ दिले नाही.',

  // guard — gate log
  log_title: 'गेट नोंद',
  log_empty_title: 'इथे काही नाही',
  log_empty_body: 'या फिल्टरशी जुळणाऱ्या एंट्री इथे दिसतील.',
  log_report_link: 'चूक कळवा',
  log_report_hdr: 'चुकीच्या एंट्रीची तक्रार करा',
  log_report_explain: 'एंट्री नोंदीत राहते — तिच्यावर खूण होते आणि सोसायटी ऑफिसला कळवले जाते. एंट्री कधीही बदलली किंवा हटवली जात नाही.',
  log_report_field: 'काय चुकले?',
  log_report_placeholder: 'उदा. चुकीचा फ्लॅट टाकला — पाहुणे B-विंगसाठी होते',
  log_report_need_reason: 'आधी काय चुकले ते सांगा.',
  log_reported_ok: 'तक्रार पाठवली — ऑफिसला कळवले आहे.',
  log_report_error: 'या एंट्रीची तक्रार पाठवता आली नाही.',
  log_reporting: 'पाठवत आहे…',
  log_report_submit: 'एंट्रीची तक्रार करा',

  // guard — messages from flats
  msgs_title: 'फ्लॅटकडून निरोप',
  msgs_empty_title: 'कोणतेही निरोप नाहीत',
  msgs_empty_body: 'रहिवासी गेटवर पाठवलेले निरोप इथे दिसतील.',

  // guard — kid exits
  kids_title: 'मुलांचे बाहेर जाणे',
  kids_intro: 'पालकांनी या मुलांना बाहेर जाऊ दिले आहे. मूल निघाल्यावर खात्री करा — फ्लॅटला कळवले जाईल.',
  kids_empty_title: 'कोणतीही चालू परवानगी नाही',
  kids_empty_body: 'पालकांच्या एक-वेळच्या परवानग्या इथे दिसतील.',
  kids_until: '{time} पर्यंत',
  kids_confirming: 'खात्री होत आहे…',
  kids_confirm: 'बाहेर जाण्याची खात्री',

  // guard — staff punch
  punch_code_label: 'स्टाफ गेट कोड',
  punch_code_help: 'त्यांचा स्वतःचा 4 अंकी कोड.',
  punch_action: 'पंच करा',
  punch_not_found: 'या कोडचा कोणताही स्टाफ सापडला नाही.',
  punch_error: 'पंच करता आले नाही. पुन्हा प्रयत्न करा.',
  punch_checked_in: 'आत आले',
  punch_checked_out: 'बाहेर गेले',

  // guard — incidents
  incidents_title: 'घटना',
  incidents_log: 'घटना नोंदवा',
  incidents_sheet_sub: 'तुम्ही नोंदवताच एडमिन आणि कमिटीला कळवले जाते.',
  incidents_field: 'काय झाले?',
  incidents_placeholder: 'उदा. गेट 2 वर एक अनोळखी दुचाकी तासभर उभी आहे',
  incidents_need_note: 'आधी घटना सांगा.',
  incidents_logged_ok: 'नोंदवले — एडमिन आणि कमिटीला अलर्ट पाठवला.',
  incidents_log_error: 'घटना नोंदवता आली नाही.',
  incidents_resolved_ok: 'निकाली काढले असे चिन्हांकित केले.',
  incidents_resolve_error: 'निकाली काढता आले नाही.',
  incidents_empty_title: 'कोणतीही घटना नाही',
  incidents_empty_body: 'गेटवर काहीही असामान्य — इथे नोंदवा आणि ऑफिसला लगेच कळेल.',
  incidents_logged_by: '{name} यांनी नोंदवले',
  incidents_mark_resolved: 'निकाली काढले चिन्हांकित करा',
  incidents_logging: 'नोंदवत आहे…',
  incidents_log_submit: 'घटना नोंदवा',
  inc_kind_security: 'सुरक्षा',
  inc_kind_fire: 'आग',
  inc_kind_medical: 'मेडिकल',
  inc_kind_maintenance: 'मेंटेनन्स',
  inc_kind_other: 'इतर',

  // common (added tranche 3)
  close: 'बंद करा',

  // parcels
  parcels_title: 'गेटवर पार्सल',
  parcels_pin_title: 'तुमचा डिलीव्हरी PIN',
  parcels_pin_sub: 'डिलीव्हरी करणारे गेटवर हा सांगून कॉल न करता पार्सल ठेवू शकतात.',
  parcels_pick_error: 'पार्सल घेतले असे चिन्हांकित करता आले नाही. पुन्हा प्रयत्न करा.',
  parcels_empty_title: 'गेटवर कोणतेही पार्सल नाही',
  parcels_empty_body: 'कुरिअरने गार्डकडे पॅकेट ठेवले की ते इथे दिसेल.',
  parcels_empty_err_title: 'पार्सल उपलब्ध नाही',
  parcels_empty_err_body: 'आत्ता गेट डेस्कशी संपर्क होत नाही.',
  parcels_at_desk: 'गार्ड डेस्कवर',
  parcels_collected: 'घेतले',
  parcels_mark_picked: 'घेतले चिन्हांकित करा',

  // gate pass — list + single pass UI (ticket face stays English)
  gp_list_title: 'गेट पास',
  gp_new: '+ नवीन',
  gp_empty_title: 'अजून कोणताही गेट पास नाही',
  gp_empty_body: 'पाहुण्याला प्री-अप्रूव्ह करा आणि QR + PIN असलेला शेअर करण्याजोगा पास बनवा.',
  gp_empty_err_title: 'पास लोड होऊ शकले नाहीत',
  gp_empty_err_body: 'थोड्या वेळाने पुन्हा प्रयत्न करा.',
  gp_preapprove_cta: 'पाहुण्याला प्री-अप्रूव्ह करा',
  gp_title: 'गेट पास',
  gp_share: 'शेअर करा',
  gp_share_to_guest: 'पाहुण्याला पाठवा',
  gp_copied: 'कॉपी झाले',
  gp_copy_code: 'कोड कॉपी करा',
  gp_copy_error: 'कोड कॉपी करता आला नाही. तो स्वतः निवडून कॉपी करा.',
  gp_share_dialog: '{name} साठी गेट पास',
  gp_info_note: 'गार्ड हे आपोआप तपासतात. तुमच्या पाहुण्याला कोणतेही ॲप लागत नाही.',
  gp_cancel_pass: 'पास रद्द करा',
  gp_revoke_error: 'हा पास आत्ता रद्द करता आला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  gp_cancelled_title: 'पास रद्द झाला',
  gp_cancelled_body: '{name} चा पास रद्द केला आहे आणि आता गेटवर वापरता येणार नाही.',
  gp_preapprove_another: 'दुसऱ्या पाहुण्याला प्री-अप्रूव्ह करा',
  gp_revoke_hdr: 'हा पास रद्द करायचा?',
  gp_revoke_body: '{name} आता हा कोड किंवा QR गेटवर वापरू शकणार नाहीत. हे परत करता येणार नाही.',
  gp_keep_pass: 'पास ठेवा',
  gp_cancelling: 'रद्द होत आहे…',

  // pre-approve visitor (big form)
  pa_title: 'पाहुण्याला प्री-अप्रूव्ह करा',
  pa_purpose: 'कारण',
  pa_purpose_guest: 'पाहुणे',
  pa_purpose_delivery: 'डिलीव्हरी',
  pa_purpose_cab: 'कॅब',
  pa_purpose_help: 'हेल्प',
  pa_how_often: 'किती वेळा',
  pa_freq_once: 'एकदा',
  pa_freq_frequent: 'वारंवार',
  pa_frequent_note: 'एक पास, अनेक वेळा एंट्री — ऑफिस कॅब, रोजची डिलीव्हरी किंवा जास्त दिवस राहणाऱ्या पाहुण्यांसाठी.',
  pa_delivery_company: 'डिलीव्हरी कंपनी',
  pa_type_of_help: 'कोणत्या प्रकारची हेल्प',
  pa_help_maid: 'मेड',
  pa_help_cook: 'कुक',
  pa_help_driver: 'ड्रायव्हर',
  pa_help_electrician: 'इलेक्ट्रिशियन',
  pa_help_plumber: 'प्लंबर',
  pa_help_carpenter: 'सुतार',
  pa_help_other: 'इतर',
  pa_help_other_ph: 'उदा. AC टेक्निशियन',
  pa_name_delivery: 'डिलीव्हरी करणाऱ्याचे नाव (आवश्यक नाही)',
  pa_name_helper: 'हेल्परचे नाव',
  pa_name_visitor: 'पाहुण्याचे नाव',
  pa_name_ph_delivery: 'कोण येणार आहे हे माहीत असल्यास',
  pa_name_ph_helper: 'उदा. रमेश यादव',
  pa_name_ph_visitor: 'उदा. संजय शर्मा',
  pa_pick_contacts: 'कॉन्टॅक्ट्समधून निवडा →',
  pa_phone: 'फोन नंबर',
  pa_phone_help: 'एंट्री कोड याच नंबरवर मिळेल.',
  pa_guest_n_name: 'पाहुणे {n} चे नाव',
  pa_remove_guest: 'पाहुणे काढा',
  pa_add_guest: '+ आणखी एक पाहुणे जोडा — प्रत्येकाला स्वतःचा पास मिळेल',
  pa_multi_title: 'अनेक वेळा एंट्री',
  pa_multi_sub: 'पाहुणे एकाच पासने वेळेत ये-जा करू शकतात.',
  pa_leave_sub: 'तुम्ही उत्तर न दिल्यास, गार्ड पार्सल गेटवर ठेवतो.',
  pa_quiet_title: 'शांतपणे एंट्री',
  pa_quiet_sub: 'सरप्राइझ भेट — गेटवर एंट्री झाल्यावर फ्लॅटला कळवू नका.',
  pa_expected_on: 'केव्हा येणार',
  pa_when_today: 'आज',
  pa_when_tomorrow: 'उद्या',
  pa_when_pickdate: 'तारीख निवडा',
  pa_date: 'तारीख',
  pa_for_next: 'पुढील',
  pa_n_days: '{n} दिवस',
  pa_arrives_around: 'साधारण येण्याची वेळ',
  pa_starts_at: 'सुरू',
  pa_daily_window: 'रोजची वेळ',
  pa_valid_for_next: 'पुढील किती वेळ',
  pa_24_hours: '24 तास',
  pa_one_hour: '1 तास',
  pa_n_hours: '{n} तास',
  pa_daily_note: 'ते दररोज येण्याच्या वेळेपासून इतके तास आत येऊ शकतात.',
  pa_send_code_title: 'अप्रूवल कोड पाठवा',
  pa_send_code_sub: 'पाहुण्याला गेटवर दाखवण्यासाठी SMS ने 6 अंकी कोड मिळेल.',
  pa_notes: 'नोट (आवश्यक नाही)',
  pa_notes_ph: 'गार्डला जे सांगायचे ते',
  pa_submit: 'पाहुण्याला प्री-अप्रूव्ह करा',
  pa_submit_named: '{name} ला प्री-अप्रूव्ह करा',
  pa_err_time: 'प्री-अप्रूव्ह करण्याआधी योग्य सुरू वेळ टाका (उदा. 6:00 PM).',
  pa_err_generic: 'पास बनवता आला नाही. इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  pa_err_unavailable: 'प्री-अप्रूव्हल अजून उपलब्ध नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  pa_err_details: 'पास बनवता आला नाही. माहिती तपासून पुन्हा प्रयत्न करा.',
  pa_err_conflict: 'हा पास आत्ता बनवता आला नाही. रिफ्रेश करून पुन्हा प्रयत्न करा.',

  // profile tab
  profile_title: 'प्रोफाइल',
  profile_edit: 'प्रोफाइल बदला',
  profile_verified: 'पडताळलेले रहिवासी',
  role_owner: 'मालक',
  role_tenant: 'भाडेकरू',
  role_family: 'कुटुंबातील सदस्य',
  role_committee_admin: 'कमिटी एडमिन',
  role_master_admin: 'मास्टर एडमिन',
  sec_account: 'खाते',
  sec_notifications: 'नोटिफिकेशन',
  sec_community_safety: 'कम्युनिटी आणि सुरक्षा',
  sec_preferences: 'सेटिंग्ज',
  sec_support: 'मदत',
  sec_management: 'व्यवस्थापन',
  row_personal_info: 'वैयक्तिक माहिती',
  row_my_flat: 'माझा फ्लॅट',
  row_family: 'कुटुंब',
  row_vehicles: 'गाड्या',
  row_notif_inbox: 'नोटिफिकेशन इनबॉक्स',
  row_residents: 'रहिवासी',
  row_visitor_history: 'पाहुणे इतिहास',
  row_emergency_sos: 'इमर्जन्सी SOS',
  row_appearance: 'दिसणे',
  appearance_dark: 'डार्क',
  appearance_light: 'लाइट',
  row_privacy: 'प्रायव्हसी',
  row_help: 'मदत आणि प्रश्न',
  row_contact: 'सपोर्टशी संपर्क',
  row_terms: 'अटी आणि प्रायव्हसी',
  row_about: 'माहिती',
  row_society_admin: 'सोसायटी एडमिन',
  row_committee_desk: 'कमिटी डेस्क',
  row_pending_actions: 'बाकी कामे',
  row_shared_access: 'शेअर केलेला ॲक्सेस',
  logout: 'लॉग आउट',

  // language picker
  lang_title: 'भाषा',
  lang_error: 'भाषा बदलता आली नाही. पुन्हा प्रयत्न करा.',
  lang_soon: 'लवकरच येत आहे',
  lang_footer: 'आणखी भाषा लवकरच येत आहेत.',

  // notification settings
  np_title: 'नोटिफिकेशन सेटिंग्ज',
  np_empty_title: 'सेटिंग्ज उपलब्ध नाहीत',
  np_empty_body: 'आत्ता तुमच्या नोटिफिकेशन सेटिंग्ज लोड होऊ शकल्या नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  np_always_on: 'सुरक्षा आणि SOS अलर्ट नेहमी सुरू असतात आणि बंद करता येत नाहीत.',
  np_update_error: 'सेटिंग बदलता आली नाही. पुन्हा प्रयत्न करा.',
  np_categories: 'श्रेणी',
  np_push: 'पुश',
  np_email: 'ईमेल',
  np_push_a11y: '{cat} पुश नोटिफिकेशन',
  np_email_a11y: '{cat} ईमेल नोटिफिकेशन',
  np_cat_notices: 'सूचना',
  np_cat_visitors: 'पाहुणे आणि सुरक्षा',
  np_cat_payments: 'पेमेंट',
  np_cat_events: 'इव्हेंट',
  np_cat_polls: 'पोल',
  np_cat_community: 'कम्युनिटी',
  np_gate_tone: 'गेट टोन',
  np_gate_tone_sub: 'जेव्हा एखादा पाहुणा तुमच्या मंजुरीची वाट पाहतो तेव्हा वाजणारा आवाज.',
  np_tone_dingdong: 'डिंग-डॉंग',
  np_tone_dingdong_sub: 'क्लासिक डोअरबेल — डिफॉल्ट',
  np_tone_chime: 'चाइम',
  np_tone_chime_sub: 'तीन सुरांची तेजस्वी घंटी',
  np_tone_marimba: 'मरिंबा',
  np_tone_marimba_sub: 'लाकडी झटपट धून — सर्वात मंद',
  np_tone_ring: 'रिंग',
  np_tone_ring_sub: 'टेलिफोनची घंटी — सर्वात मोठी',
  np_tone_a11y: '{name} गेट टोन',
  np_play: 'वाजवा',
  np_play_a11y: '{name} वाजवा',

  // common (added tranche 5)
  search: 'शोधा',

  // community tab
  ct_tab_notices: 'सूचना',
  ct_tab_discussions: 'चर्चा',
  ct_tab_polls: 'पोल',
  ct_tab_events: 'इव्हेंट',
  ct_tab_issues: 'तक्रारी',
  ml_vendors: 'व्हेंडर',
  ml_classifieds: 'क्लासिफाइड',
  ml_lost_found: 'हरवले-सापडले',
  ml_celebrations: 'सोहळे',
  ct_check_connection: 'तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  notice_kind_urgent: 'तातडीचे',
  notice_kind_event: 'इव्हेंट',
  notice_kind_committee: 'कमिटी',
  notice_kind_general: 'सामान्य',
  ct_notices_err_title: 'सूचना लोड होऊ शकल्या नाहीत',
  ct_notices_empty_title: 'अजून कोणतीही सूचना नाही',
  ct_notices_empty_body: 'तुमच्या कमिटीच्या सूचना इथे दिसतील.',
  ct_pinned: 'पिन केले',
  ct_all_notices: 'सर्व सूचना',
  ct_disc_err_title: 'चर्चा लोड होऊ शकल्या नाहीत',
  ct_disc_empty_title: 'अजून कोणतीही चर्चा नाही',
  ct_disc_empty_body: 'तुमच्या कम्युनिटीत एखादी चर्चा सुरू करा, ती इथे दिसेल.',
  ct_reply: '1 उत्तर',
  ct_replies: '{n} उत्तरे',
  ct_views: '{n} व्ह्यू',
  ct_nothing_here: 'इथे काही नाही',
  ct_disc_none_body: 'या टॅगची कोणतीही चर्चा अजून नाही.',
  ct_polls_err_title: 'पोल लोड होऊ शकले नाहीत',
  ct_active_polls: 'चालू पोल',
  ct_see_all: 'सर्व पहा →',
  ct_polls_empty_title: 'कोणताही चालू पोल नाही',
  ct_polls_empty_body: 'कमिटी एखादा पोल सुरू करेल तेव्हा तो इथे दिसेल.',
  ct_anonymous: 'निनावी',
  ct_voted: '{total} पैकी {n} जणांनी मत दिले',
  poll_all_wings: 'सर्व विंग',
  poll_wing: 'विंग {code}',
  poll_closed: 'बंद',
  poll_open: 'खुला',
  poll_closes_today: 'आज बंद होईल',
  poll_closes_tomorrow: 'उद्या बंद होईल',
  poll_closes_in: '{n} दिवसांत बंद होईल',
  ct_events_err_title: 'इव्हेंट लोड होऊ शकले नाहीत',
  ct_events_empty_title: 'अजून कोणताही इव्हेंट नाही',
  ct_events_empty_body: 'सोसायटीचे येणारे इव्हेंट इथे दिसतील.',
  ct_upcoming: 'येणारे',
  ct_no_upcoming: 'आत्ता कोणताही येणारा इव्हेंट नाही.',
  ct_past: 'मागील',
  ct_issues_err_title: 'तक्रारी लोड होऊ शकल्या नाहीत',
  ct_community_issues: 'कम्युनिटी तक्रारी',
  ct_issues_empty_title: 'कोणतीही कम्युनिटी तक्रार नाही',
  ct_issues_empty_body: 'संपूर्ण कम्युनिटीसाठी केलेल्या तक्रारी इथे दिसतील.',
  ct_comments: '{n} कमेंट',
  ct_select_subtab: 'वरून एखादा सब-टॅब निवडा — त्याचा मजकूर उजवीकडील पॅनलमध्ये उघडेल.',
  ct_select_notice_title: 'एखादी सूचना निवडा',
  ct_select_notice_body: 'वाचण्यासाठी यादीतून एखादी सूचना निवडा.',
  ct_acknowledged: 'वाचले',
  ct_ack_count: '{n} जणांनी वाचले',

  // pay tab
  pay_title: 'पेमेंट',
  pay_how_to_pay: 'पेमेंट कसे करावे',
  pay_bank: 'बँक',
  pay_account: 'खाते',
  pay_how_to_pay_note: 'तुमच्या बँक किंवा UPI ॲपमधून नोटमध्ये तुमचा फ्लॅट नंबर टाकून पेमेंट करा. सोसायटीचा ट्रेझरर ते नोंदवतो आणि तुमचे बिल इथे PAID होते.',
  pay_record_hdr: 'पेमेंट नोंदवा · ट्रेझरर',
  pay_no_unpaid: 'कोणतेही थकीत बिल नाही — सर्व नोंदवले आहे.',
  pay_the_flat: 'फ्लॅट',
  pay_flat: 'फ्लॅट',
  pay_recorded_ok: '{flat} कडून {amount} नोंदवले — बिल पेड मार्क झाले.',
  pay_record_error: 'पेमेंट नोंदवता आले नाही.',
  pay_due: 'देय {date}',
  pay_includes_late: '{amount} लेट फी समाविष्ट',
  pay_received: 'मिळाले',
  pay_err_title: 'पेमेंट उपलब्ध नाही',
  pay_err_body: 'आत्ता तुमचे बिल लोड होऊ शकले नाही. इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  pay_no_dues_title: 'आत्ता कोणतीही थकबाकी नाही',
  pay_no_dues_body: 'या महिन्याचे कोणतेही बिल नाही. पुढच्या महिन्यात पहा, किंवा खाली तुमची बिल हिस्ट्री पहा.',
  pay_fully_paid: '{month} पूर्ण भरले',
  pay_recorded_on: '{date} रोजी नोंदवले',
  pay_no_outstanding: 'कोणतीही थकबाकी नाही',
  pay_view_breakdown: 'ब्रेकडाउन पहा',
  pay_past_bills: 'मागील बिले',
  pay_recent_bills: 'अलीकडील बिले',
  pay_view_all: 'सर्व पहा →',
  pay_no_history: 'अजून कोणतीही पेमेंट हिस्ट्री नाही.',
  pay_breakdown: '{month} चा ब्रेकडाउन',
  pay_subtotal: 'सबटोटल',
  pay_late_fee: 'लेट फी',
  pay_total_due: 'एकूण देय',
  pay_record_title: '{flat} कडून {amount} नोंदवा',
  pay_record_sub: '{month} · पावत्या ट्रेझररकडून नोंदवल्या जातात (बाय-लॉ 113) आणि सोसायटीच्या ऑडिट रेकॉर्डमध्ये येतात.',
  pay_received_via: 'कशाद्वारे मिळाले',
  pay_method_cash: 'रोख',
  pay_method_cheque: 'चेक',
  pay_method_card: 'कार्ड',
  pay_reference: 'रेफरन्स',
  pay_reference_help: 'UTR / चेक नंबर — आवश्यक नाही पण हिशेबासाठी चांगले',
  pay_recording: 'नोंदवत आहे…',
  pay_record_received: 'मिळाले म्हणून नोंदवा',
  pay_due_by: '{date} पर्यंत देय',
  pay_invoice_label: 'इनव्हॉइस',
  pay_overdue_since: '{date} पासून थकीत',
  pay_plus_late: '+ लेट फी',
  pay_col_invoice: 'इनव्हॉइस',
  pay_col_period: 'कालावधी',
  pay_col_amount: 'रक्कम',
  pay_col_status: 'स्थिती',

  // bills & receipts history
  bh_title: 'बिले आणि पावत्या',
  bh_err_title: 'बिले उपलब्ध नाहीत',
  bh_err_body: 'आत्ता तुमची बिल हिस्ट्री लोड होऊ शकली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  bh_empty_title: 'अजून कोणतेही बिल नाही',
  bh_empty_body: 'तुमची महिन्याची मेंटेनन्स बिले तयार झाल्यावर इथे दिसतील.',
  bh_paid_in: '{year} मध्ये भरले',
  bh_streak: 'वेळेवर भरणा',
  bh_months: '{n} महिने',
  bh_print_notice: 'प्रिंट करण्यासाठी पुढील ॲप अपडेट लागेल — ते नवीन बिल्डसोबत येईल.',
  bh_col_receipt: 'पावती',
  bh_receipt: 'पावती',
  bh_invoice: 'इनव्हॉइस',
  bh_download_a11y: '{month} {doc} डाउनलोड करा',
  bh_paid_on: '{date} रोजी भरले',
  bh_incl_late: 'लेट फी समाविष्ट',

  // helpdesk
  hd_title: 'हेल्पडेस्क',
  hd_open: 'खुले ({n})',
  hd_resolved: 'निकाली ({n})',
  hd_err_title: 'हेल्पडेस्क उपलब्ध नाही',
  hd_err_body: 'आत्ता तुमची तिकिटे लोड होऊ शकली नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  hd_no_open: 'कोणतेही खुले तिकीट नाही',
  hd_no_open_body: 'तुमच्या सर्व समस्या सुटल्या आहेत. नवीन तिकीट काढण्यासाठी + दाबा.',
  hd_no_resolved: 'कोणतेही निकाली तिकीट नाही',
  hd_no_resolved_body: 'तुम्ही बंद केलेली तिकिटे इथे दिसतील.',
  hd_how_moves: 'तिकीट कसे पुढे जाते',
  hd_j_raised: 'नोंदवले',
  hd_j_raised_sub: 'तुम्ही समस्या सांगता, फोटो जोडता',
  hd_j_assigned: 'सोपवले',
  hd_j_assigned_sub: 'फॅसिलिटी मॅनेजर व्हेंडर निवडतो',
  hd_j_resolved: 'निकाली + रेटिंग',
  hd_j_resolved_sub: 'तुम्ही खात्री करता आणि कामाला रेट देता',
  hd_new_ticket: 'नवीन तिकीट',
  hd_updated: '{time} रोजी अपडेट',
  hd_category: 'श्रेणी',
  hd_field_title: 'शीर्षक',
  hd_title_help: 'छोटे ठेवा — जास्तीत जास्त 100 अक्षरे.',
  hd_title_ph: 'उदा. किचनचे सिंक गळत आहे',
  hd_description: 'तपशील',
  hd_desc_ph: 'काय आणि कुठे बिघडले आहे ते सांगा.',
  hd_photos: 'फोटो',
  hd_location: 'ठिकाण',
  hd_loc_personal: 'वैयक्तिक (माझा फ्लॅट)',
  hd_loc_common: 'कॉमन एरिया',
  hd_priority: 'प्राधान्य',
  hd_prio_normal: 'सामान्य',
  hd_prio_urgent: 'तातडीचे',
  hd_raise_error: 'तिकीट नोंदवता आले नाही. पुन्हा प्रयत्न करा.',
  hd_raise: 'तिकीट नोंदवा',
  hd_details: 'तिकीट तपशील',
  hd_detail_err_title: 'तिकीट उपलब्ध नाही',
  hd_detail_err_body: 'हे तिकीट काढून टाकले गेले असावे, किंवा लोड करताना काहीतरी बिघडले.',
  hd_raised_by: 'कोणी नोंदवले',
  hd_you: 'तुम्ही',
  hd_raised_on: 'कधी नोंदवले',
  hd_assigned_to: 'कोणाला सोपवले',
  hd_not_assigned: 'अजून सोपवले नाही',
  hd_expected_by: 'कधीपर्यंत',
  hd_tbc: 'नंतर ठरेल',
  hd_timeline: 'प्रगती टाइमलाइन',
  hd_status_updated: 'स्थिती अपडेट झाली',
  hd_commented: '{author} यांनी कमेंट केले',
  hd_awaiting: 'निकालाची वाट',
  hd_pending: 'पूर्ण होणे बाकी',
  hd_comment_error: 'तुमचे कमेंट पोस्ट होऊ शकले नाही. पुन्हा प्रयत्न करा.',
  hd_attach_photo: 'फोटो जोडा',
  hd_add_comment: 'कमेंट जोडा…',
  hd_send_comment: 'कमेंट पाठवा',
  hd_cat_plumbing: 'प्लंबिंग',
  hd_cat_electrical: 'वीज',
  hd_cat_security: 'सुरक्षा',
  hd_cat_lift: 'लिफ्ट',
  hd_cat_pest: 'पेस्ट कंट्रोल',
  hd_cat_cleaning: 'साफसफाई',
  hd_cat_other: 'इतर',

  // amenity booking
  am_title: 'सुविधा बुक करा',
  am_my_bookings: 'माझ्या बुकिंग',
  am_err_title: 'सुविधा उपलब्ध नाहीत',
  am_err_body: 'आत्ता सुविधांचे स्लॉट लोड होऊ शकले नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  am_empty_title: 'कोणतीही सुविधा सेट केलेली नाही',
  am_empty_body: 'तुमच्या सोसायटीने अजून कोणतीही बुक करण्याजोगी सुविधा तयार केलेली नाही.',
  am_per_slot: '/स्लॉट',
  am_today_date: 'आज · {date}',
  am_open: 'रिकामे',
  am_taken: 'बुक',
  am_rules: 'नियम',
  am_confirm: 'बुकिंग निश्चित करा',
  am_booked_by: '{name} यांनी बुक केले',
  am_you: 'तुम्ही',
  am_charges: 'शुल्क',
  am_free: 'मोफत',
  am_conflict: 'हा स्लॉट आत्ताच दुसऱ्या कोणीतरी बुक केला. दुसरा निवडा.',
  am_book_error: 'हा स्लॉट बुक करता आला नाही. पुन्हा प्रयत्न करा.',
  am_slot_booked: 'स्लॉट बुक झाला',
  am_view_bookings: 'माझ्या बुकिंग पहा',
  am_done: 'झाले',

  // venue booking
  vb_title: 'व्हेन्यू बुक करा',
  vb_err_title: 'व्हेन्यू उपलब्ध नाहीत',
  vb_err_body: 'आत्ता बुक करण्याजोगे व्हेन्यू लोड होऊ शकले नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  vb_empty_title: 'कोणताही व्हेन्यू सेट केलेला नाही',
  vb_empty_body: 'तुमच्या सोसायटीने अजून पूर्ण दिवसासाठी कोणताही व्हेन्यू तयार केलेला नाही.',
  vb_booked: 'व्हेन्यू बुक झाला',
  vb_submitted: 'बुकिंग विनंती पाठवली',
  vb_confirmed: 'तुमची बुकिंग निश्चित झाली.',
  vb_pending: 'एडमिनच्या मंजुरीची वाट आहे. आढावा घेतल्यावर ती "माझ्या बुकिंग"मध्ये दिसेल.',
  vb_book_another: 'दुसरी तारीख बुक करा',
  vb_choose_venue: 'व्हेन्यू निवडा',
  vb_up_to: '{n} दिवस आधीपर्यंत',
  vb_pick_day: 'पूर्ण दिवस निवडा',
  vb_purpose: 'कारण',
  vb_purpose_help: 'व्हेन्यू कशासाठी आहे ते कमिटीला सांगा.',
  vb_purpose_ph: 'उदा. मुलीची वाढदिवस पार्टी',
  vb_info: 'प्रत्येक तारखेला प्रत्येक व्हेन्यूची एकच पूर्ण दिवसाची बुकिंग. आधीच बुक केलेल्या तारखा धूसर दिसतात.',
  vb_conflict: 'ही तारीख या व्हेन्यूसाठी आत्ताच दुसऱ्या कोणीतरी घेतली. दुसरी निवडा.',
  vb_submit_error: 'बुकिंग पाठवता आली नाही. पुन्हा प्रयत्न करा.',
  vb_request: 'बुकिंग विनंती करा',

  // my bookings
  mb_err_title: 'बुकिंग उपलब्ध नाहीत',
  mb_err_body: 'आत्ता तुमच्या बुकिंग लोड होऊ शकल्या नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  mb_empty_title: 'अजून कोणतीही बुकिंग नाही',
  mb_empty_body: 'तुम्ही बुक केलेले सुविधा स्लॉट आणि व्हेन्यू विनंत्या इथे दिसतील.',
  mb_venues_for_functions: 'कार्यक्रमांसाठी व्हेन्यू',
  mb_cancel_error: 'ही बुकिंग रद्द करता आली नाही. पुन्हा प्रयत्न करा.',
  mb_up_to_guests: '{n} पाहुण्यांपर्यंत',
  mb_days_ahead: '{n} दिवस आधी',
  mb_amenity: 'सुविधा',
  mb_venue: 'व्हेन्यू',
  mb_cancel_confirm: 'ही बुकिंग रद्द करायची?',
  mb_keep: 'राहू द्या',
  mb_yes_cancel: 'होय, रद्द करा',
  mb_cancel_booking: 'बुकिंग रद्द करा',

  // residents directory
  res_search_ph: 'नाव किंवा फ्लॅटने शोधा',
  res_wing: '{w} विंग',
  res_err_title: 'डिरेक्टरी उपलब्ध नाही',
  res_err_body: 'आत्ता रहिवासी डिरेक्टरी लोड होऊ शकली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  res_empty_title: 'अजून कोणतेही रहिवासी नाहीत',
  res_empty_body: 'तुमच्या सोसायटीचे मंजूर रहिवासी इथे दिसतील.',
  res_privacy_note: 'रहिवासी काय शेअर करायचे ते स्वतः ठरवतात. काही माहिती लपलेली असू शकते.',
  res_no_matches: 'काहीही सापडले नाही',
  res_no_matches_body: 'दुसरे नाव, फ्लॅट किंवा विंग वापरून पहा.',
  res_private: 'खाजगी',

  // family & passes
  fp_title: 'कुटुंब आणि पास',
  fp_add: 'कुटुंब सदस्य जोडा',
  fp_permanent: 'कायमचे पास',
  fp_note: 'कायमचा पास असलेले कुटुंब दरवेळी मंजुरीशिवाय आत येतात.',
  fp_err_title: 'कुटुंब आणि पास उपलब्ध नाहीत',
  fp_err_body: 'आत्ता तुमची कुटुंब यादी लोड होऊ शकली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  fp_empty_title: 'अजून कोणतेही कुटुंब सदस्य नाहीत',
  fp_empty_body: 'कुटुंब जोडा जेणेकरून ते दरवेळी मंजुरीशिवाय आत येऊ शकतील.',
  fp_add_error: 'हा सदस्य आत्ता जोडता आला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  fp_schedules: 'शेड्यूल',
  fp_pass_active: 'पास चालू',
  fp_pending: 'बाकी',
  fp_relation: 'नाते',
  fp_relation_ph: 'पती/पत्नी, आई-वडील, मूल…',
  fp_is_kid: 'हे मूल आहे (नियमित शेड्यूल हवे)',
  fp_is_kid_short: 'हे मूल आहे',
  fp_add_member: 'सदस्य जोडा',

  // kids permissions
  kp_title: 'मुलांच्या परवानग्या',
  kp_add_window: 'विंडो जोडा',
  kp_allow_now: 'माझ्या मुलाला आत्ता बाहेर जाऊ द्या',
  kp_allow_now_sub: 'एक-वेळची परवानगी — गेट त्यांना वेळेत बाहेर जाऊ देतो.',
  kp_child_name: 'मुलाचे नाव',
  kp_allow_named: '{name} ला {h} तास बाहेर जाऊ द्या',
  kp_allow_out: 'बाहेर जाऊ द्या',
  kp_info: 'या नियमित वेळांमध्ये मुलांना आपोआप बाहेर जाऊ दिले जाते. गार्डला आधीच कळते.',
  kp_err_title: 'मुलांच्या परवानग्या उपलब्ध नाहीत',
  kp_err_body: 'या आत्ता लोड होऊ शकल्या नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  kp_empty_title: 'कोणतीही नियमित विंडो नाही',
  kp_empty_body: 'शाळेची पिकअप किंवा क्लाससारखी नियमित विंडो जोडा जेणेकरून ती आपोआप मंजूर होईल.',
  kp_toggle_error: 'ही विंडो अपडेट होऊ शकली नाही. पुन्हा प्रयत्न करा.',
  kp_allow_error: 'बाहेर जाण्याची परवानगी बनवता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  kp_save_error: 'बदल सेव्ह होऊ शकले नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  kp_add_error: 'ही विंडो आत्ता जोडता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  kp_remove_error: 'ही विंडो काढता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  kp_child: 'मूल',
  kp_edit_window: 'नियमित विंडो बदला',
  kp_add_recurring: 'नियमित विंडो जोडा',
  kp_kid_ph: 'उदा. आन्या',
  kp_activity: 'उपक्रम',
  kp_activity_ph: 'उदा. स्कूल बस',
  kp_schedule: 'शेड्यूल',
  kp_schedule_ph: 'सोम–शुक्र · 7:30–8:00 AM',
  kp_escort: 'सोबत कोण',
  kp_escort_ph: 'ब्राइट फ्यूचर स्कूल',
  kp_save: 'बदल सेव्ह करा',
  kp_remove: 'ही विंडो काढा',

  // move-in / move-out
  mo_title: 'शिफ्टिंग विनंती',
  mo_request_type: 'विनंतीचा प्रकार',
  mo_movein: 'मूव्ह-इन',
  mo_moveout: 'मूव्ह-आउट',
  mo_preferred_date: 'पसंतीची तारीख',
  mo_time_slot: 'वेळ स्लॉट',
  mo_vehicle: 'सामानाची गाडी नंबर',
  mo_helpers: 'मदतनीसांची संख्या',
  mo_notes: 'नोट (आवश्यक नाही)',
  mo_notes_ph: 'लिफ्ट बुकिंग, नाजूक सामान, इ.',
  mo_deposit: 'परतावा मिळणारी ठेव',
  mo_applies: 'लागू आहे',
  mo_lift: 'सर्व्हिस लिफ्ट बुकिंग',
  mo_included: 'समाविष्ट',
  mo_approval: 'कमिटीची मंजुरी',
  mo_required: 'आवश्यक',
  mo_submitted: '{type} विनंती एडमिनच्या मंजुरीसाठी पाठवली.',
  mo_err_details: 'विनंती पाठवता आली नाही. तारीख आणि वेळ स्लॉट तपासून पुन्हा प्रयत्न करा.',
  mo_err_generic: 'विनंती आत्ता पाठवता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  mo_submit: 'विनंती पाठवा',
  mo_your_requests: 'तुमच्या विनंत्या',
  mo_no_requests: 'अजून कोणतीही शिफ्टिंग विनंती नाही.',
  mo_request_title: '{type} विनंती',
  mo_date: 'तारीख',
  mo_goods_vehicle: 'सामानाची गाडी',
  mo_helpers_label: 'मदतनीस',
  mo_submitted_label: 'पाठवली',
  mo_waiting: 'कमिटीच्या मंजुरीची वाट. मंजूर होईपर्यंत तुम्ही रद्द करू शकता.',
  mo_cancel: 'ही विनंती रद्द करा',
  mo_cancel_error: 'ही विनंती रद्द करता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',

  // attendance
  at_title: 'हजेरी',
  at_prev_month: 'मागील महिना',
  at_next_month: 'पुढील महिना',
  at_err_title: 'हजेरी उपलब्ध नाही',
  at_err_body: 'आत्ता हजेरीचा रेकॉर्ड लोड होऊ शकला नाही.',
  at_empty_title: 'या महिन्यात कोणतीही एंट्री नाही',
  at_empty_body: '{month} साठी अजून कोणताही इन/आउट रेकॉर्ड नाही.',
  at_no_records: 'या महिन्याचा कोणताही रेकॉर्ड नाही.',
  at_absent: 'गैरहजर',

  // vehicles
  veh_title: 'माझ्या गाड्या',
  veh_add: 'गाडी जोडा',
  veh_car: 'कार',
  veh_two_wheeler: 'दुचाकी',
  veh_other: 'इतर',
  veh_plate_error: 'गाडीचा नंबर प्लेट टाका.',
  veh_dup_error: 'हा नंबर तुमच्या सोसायटीत आधीच नोंदवला आहे.',
  veh_add_error: 'गाडी जोडता आली नाही. इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  veh_err_title: 'गाड्या उपलब्ध नाहीत',
  veh_err_body: 'आत्ता तुमच्या गाड्या लोड होऊ शकल्या नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  veh_empty_title: 'अजून कोणतीही गाडी नाही',
  veh_empty_body: 'तुमची कार किंवा दुचाकी नोंदवा जेणेकरून गेट तिला ओळखेल.',
  veh_add_cta: 'गाडी जोडा',
  veh_sticker: 'पार्किंग स्टिकर',
  veh_plate: 'नंबर प्लेट',
  veh_type: 'प्रकार',
  veh_model: 'मॉडेल (आवश्यक नाही)',
  veh_model_ph: 'उदा. हुंडई क्रेटा · पांढरी',
  veh_sticker_field: 'पार्किंग स्टिकर (आवश्यक नाही)',
  veh_sticker_ph: 'उदा. A-601-C1',

  // delivery auto-approval PIN
  dp_title: 'डिलीव्हरी ऑटो-अप्रूव्हल',
  dp_err_title: 'डिलीव्हरी PIN उपलब्ध नाही',
  dp_err_body: 'आत्ता तुमचा गेट PIN लोड होऊ शकला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  dp_auto_approve: 'डिलीव्हरी आपोआप मंजूर करा',
  dp_auto_approve_sub: 'डिलीव्हरी करणारे गेटवर तुमचा PIN टाकून तुम्हाला त्रास न देता आत येतात.',
  dp_rotates: 'दर महिन्याला बदलतो',
  dp_generating: 'तयार होत आहे…',
  dp_regenerate: 'नवीन PIN तयार करा',
  dp_warn: 'फक्त विश्वासू डिलीव्हरी ॲपसोबत शेअर करा. प्रत्येक वापर फोटोसह नोंदवला जातो.',
  dp_regenerated: 'नवीन PIN तयार झाला. जुना PIN लगेच बंद होतो.',
  dp_regen_error: 'PIN आत्ता पुन्हा तयार करता आला नाही.',

  // message the gate
  mg_title: 'गेटला निरोप पाठवा',
  mg_info: 'थेट गार्ड डेस्कवर जातो. इमर्जन्सीसाठी SOS वापरा — हे रोजच्या सूचनांसाठी आहे.',
  mg_placeholder: 'उदा. फर्निचर टेम्पो साधारण 5 वाजता येत आहे — कृपया त्याला सर्व्हिस लिफ्टपर्यंत येऊ द्या.',
  mg_send_error: 'हे पाठवता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  mg_send: 'गेटवर पाठवा',
  mg_sent: 'पाठवलेले',
  mg_empty_title: 'अजून काही पाठवले नाही',
  mg_empty_body: 'तुम्ही गेटला पाठवलेले निरोप इथे पाहिले-गेले स्थितीसह दिसतील.',

  // party invite
  pi_title: 'पार्टी आमंत्रण',
  pi_intro: 'संपूर्ण कार्यक्रमासाठी एकच लिंक — प्रत्येक पाहुणा ती टॅप करून स्वतःचा गेट पास मिळवतो.',
  pi_occasion: 'कोणता प्रसंग आहे?',
  pi_occasion_ph: 'उदा. आरवचा वाढदिवस',
  pi_when: 'केव्हा',
  pi_open_for: 'किती वेळ खुले',
  pi_guest_limit: 'पाहुण्यांची मर्यादा',
  pi_n_guests: '{n} पाहुणे',
  pi_create_named: '{title} साठी आमंत्रण तयार करा',
  pi_create: 'आमंत्रण तयार करा',
  pi_your_invites: 'तुमची आमंत्रणे',
  pi_empty_title: 'अजून कोणतेही आमंत्रण नाही',
  pi_empty_body: 'वर एक तयार करा — वाढदिवस, पूजा आणि घरगुती पार्ट्यांसाठी उत्तम.',
  pi_claimed: '{total} पैकी {n} पास घेतले',
  pi_copied: 'लिंक कॉपी झाली',
  pi_share: 'लिंक शेअर करा',
  pi_cancelling: 'रद्द होत आहे…',
  pi_time_error: 'योग्य सुरू वेळ टाका (उदा. 6:00 PM).',
  pi_created: 'आमंत्रण तयार झाले — लिंक तुमच्या पाहुण्यांसोबत शेअर करा.',
  pi_create_error: 'आमंत्रण आत्ता तयार होऊ शकले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  pi_cancel_error: 'हे आमंत्रण रद्द करता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',

  // classifieds
  cl_err_title: 'क्लासिफाइड लोड होऊ शकले नाहीत',
  cl_err_body: 'लिस्टिंग आणताना काहीतरी बिघडले. तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  cl_empty_title: 'अजून कोणतीही लिस्टिंग नाही',
  cl_empty_body: 'रहिवाशांना विकायच्या किंवा द्यायच्या वस्तू इथे दिसतील.',

  // lost & found
  lf_err_title: 'हरवले-सापडले लोड होऊ शकले नाही',
  lf_err_body: 'वस्तू आणताना काहीतरी बिघडले. तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  lf_empty_title: 'काहीही नोंदवले नाही',
  lf_empty_body: 'रहिवाशांनी नोंदवलेल्या हरवलेल्या किंवा सापडलेल्या वस्तू इथे दिसतील.',

  // celebrations
  bd_share: 'माझे सोहळे शेअर करा',
  bd_share_sub: 'शेजारी तुमच्या खास दिवशी तुम्हाला शुभेच्छा देऊ शकतात.',
  bd_err_title: 'सोहळे लोड होऊ शकले नाहीत',
  bd_err_body: 'सोहळे आणताना काहीतरी बिघडले. तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  bd_empty_title: 'या आठवड्यात कोणताही सोहळा नाही',
  bd_empty_body: 'सोसायटीतील वाढदिवस आणि वर्धापनदिन इथे दिसतील.',
  bd_this_week: 'या आठवड्यात',
  bd_wished_count: '{n} जणांनी शुभेच्छा दिल्या',
  bd_wished: 'शुभेच्छा दिल्या',
  bd_wish: 'शुभेच्छा द्या',

  // personal info
  pinfo_name_error: 'तुमचे पूर्ण नाव टाका.',
  pinfo_save_error: 'तुमची प्रोफाइल आत्ता सेव्ह होऊ शकली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  pinfo_change_photo: 'फोटो बदला',
  pinfo_photo_unavailable: 'फोटो अपलोड अजून उपलब्ध नाही.',
  pinfo_phone: 'फोन',
  pinfo_email_help: 'ईमेल बदलता येत नाही — तोच तुमचा साइन-इन आहे.',
  pinfo_show_phone: 'रहिवासी डिरेक्टरीमध्ये माझा फोन दाखवा',
  pinfo_visible: 'दाखवा',
  pinfo_flat_note: 'फ्लॅट आणि मालकीची माहिती तुमच्या सोसायटी एडमिन सांभाळतात.',

  // change password
  cp_title: 'पासवर्ड बदला',
  cp_current: 'सध्याचा पासवर्ड',
  cp_new: 'नवीन पासवर्ड',
  cp_confirm: 'नवीन पासवर्ड पुन्हा टाका',
  cp_update: 'पासवर्ड अपडेट करा',
  cp_current_error: 'तुमचा सध्याचा पासवर्ड टाका.',
  cp_weak: 'किमान 8 अक्षरे आणि एक अंक.',
  cp_mismatch: 'पासवर्ड जुळत नाहीत.',
  cp_wrong_current: 'सध्याचा पासवर्ड चुकीचा आहे.',
  cp_generic_error: 'पासवर्ड आत्ता अपडेट होऊ शकला नाही.',
  cp_done_title: 'पासवर्ड अपडेट झाला',
  cp_done_body: 'पुढच्या वेळी साइन इन करताना तुमचा नवीन पासवर्ड वापरा.',

  // deactivate account
  da_title: 'खाते बंद करा',
  da_your_flat: 'तुमच्या फ्लॅट',
  da_password_error: 'खात्रीसाठी तुमचा पासवर्ड टाका.',
  da_wrong_password: 'पासवर्ड चुकीचा आहे.',
  da_generic_error: 'विनंती आत्ता पाठवता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  da_heading: 'खाते बंद करण्याची विनंती',
  da_body: 'तुमच्या सोसायटी एडमिन या विनंतीचा आढावा घेतील. मंजूर झाल्यावर तुम्ही {flat} साठी सूचना, पेमेंट आणि गेट सुविधांचा ॲक्सेस गमावाल. आधी थकबाकी भरणे आवश्यक आहे.',
  da_reason: 'कारण (आवश्यक नाही)',
  da_reason_ph: 'शिफ्ट होत आहे, फ्लॅट विकत आहे, इ.',
  da_confirm_pw: 'तुमच्या पासवर्डने खात्री करा',
  da_request: 'बंद करण्याची विनंती पाठवा',

  // my flat
  mf_title: 'माझा फ्लॅट',
  mf_err_title: 'फ्लॅटची माहिती उपलब्ध नाही',
  mf_err_body: 'आत्ता तुमचा फ्लॅट लोड होऊ शकला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  mf_registered: 'तुमचा नोंदवलेला फ्लॅट',
  mf_ownership: 'मालकी',
  mf_carpet: 'कारपेट एरिया',
  mf_parking: 'पार्किंग',
  mf_residents: 'रहिवासी आणि कुटुंब',
  mf_you: 'तुम्ही',

  // notifications inbox
  nb_mark_all: 'सर्व वाचले चिन्हांकित करा',
  nb_read_error: 'वाचले चिन्हांकित करता आले नाही. पुन्हा प्रयत्न करा.',
  nb_read_all_error: 'सर्व वाचले चिन्हांकित करता आले नाही. पुन्हा प्रयत्न करा.',
  nb_err_title: 'नोटिफिकेशन उपलब्ध नाहीत',
  nb_err_body: 'आत्ता तुमचे नोटिफिकेशन लोड होऊ शकले नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  nb_empty_title: 'सर्व पाहून झाले',
  nb_empty_body: 'मंजुरी, सूचना आणि पेमेंट अपडेट इथे येतील.',

  // emergency contacts
  em_title: 'इमर्जन्सी कॉन्टॅक्ट',
  em_all_contacts: 'सर्व कॉन्टॅक्ट',
  em_security: 'सुरक्षा',
  em_no_guards: 'कोणतेही गार्ड सूचीबद्ध नाहीत',
  em_no_guards_body: 'तुमची सोसायटी गेट स्टाफ जोडेल तेव्हा ते इथे दिसतील.',
  em_guard_note: 'तुमचे गेट, एका टॅपवर — ड्युटीवरील गार्डला थेट कॉल करा.',
  em_err_title: 'कॉन्टॅक्ट उपलब्ध नाहीत',
  em_err_body: 'आत्ता तुमचे इमर्जन्सी कॉन्टॅक्ट लोड होऊ शकले नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  em_empty_title: 'कोणतेही इमर्जन्सी कॉन्टॅक्ट नाहीत',
  em_empty_body: 'इथे जोडलेल्या कॉन्टॅक्टना SOS दाबल्यावर आपोआप कॉल जातो.',
  em_sos_note: 'या कॉन्टॅक्टना SOS दाबल्यावर आपोआप कॉल जातो.',

  // society directory
  dir_flats: '{n} फ्लॅट',
  dir_residents: '{n} रहिवासी',
  dir_empty_title: 'अजून इथे काही नाही',
  dir_err_body: 'आत्ता सोसायटी डिरेक्टरी लोड होऊ शकली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  dir_empty_body: 'सोसायटीचे कॉन्टॅक्ट आणि विंगची माहिती इथे दिसेल.',
  dir_wings: 'विंग',
  dir_contacts: 'सोसायटी कॉन्टॅक्ट',
  dir_resident_dir: 'रहिवासी डिरेक्टरी',

  // global search
  sr_back: 'मागे',
  sr_placeholder: 'सूचना, लोक, इव्हेंट शोधा…',
  sr_idle_title: 'तुमच्या सोसायटीत शोधा',
  sr_idle_body: 'सूचना, इव्हेंट, व्हेंडर आणि रहिवासी शोधा. किमान दोन अक्षरे टाइप करा.',
  sr_err_title: 'शोध उपलब्ध नाही',
  sr_err_body: 'आत्ता शोध घेता आला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  sr_no_matches_body: '“{q}” साठी काहीही सापडले नाही. एखादे नाव, फ्लॅट किंवा सूचना शीर्षक वापरून पहा.',

  // document vault
  doc_upload: 'अपलोड',
  doc_too_big: 'ही फाइल 5 MB पेक्षा मोठी आहे — ती कमी करून पुन्हा प्रयत्न करा.',
  doc_picker_error: 'फाइल पिकर उघडू शकला नाही.',
  doc_title_error: 'कागदपत्राला एक शीर्षक द्या.',
  doc_uploaded: '“{name}” व्हॉल्टमध्ये आहे.',
  doc_upload_error: 'अपलोड होऊ शकले नाही.',
  doc_removed: '“{name}” काढले — ऑडिट रेकॉर्डमध्ये नोंदवले.',
  doc_remove_error: 'काढता आले नाही.',
  doc_err_title: 'कागदपत्रे उपलब्ध नाहीत',
  doc_err_body: 'आत्ता तुमची कागदपत्रे लोड होऊ शकली नाहीत. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  doc_empty_title: 'अजून कोणतेही कागदपत्र नाही',
  doc_empty_body: 'तुमच्यासोबत शेअर केलेल्या पावत्या, सोसायटीची पत्रे आणि NOC इथे दिसतील.',
  doc_search_ph: 'कागदपत्रे शोधा',
  doc_no_matches_body: '“{q}” शी कोणतेही कागदपत्र जुळत नाही.',
  doc_remove: 'काढा',
  doc_upload_hdr: 'व्हॉल्टमध्ये अपलोड करा',
  doc_upload_sub: 'PDF किंवा फोटो, 5 MB पर्यंत. प्रत्येक सदस्य व्हॉल्ट वाचू शकतो; अपलोड ऑडिट रेकॉर्डमध्ये नोंदवले जातात (बाय-लॉ 140(17)).',
  doc_change: 'बदला',
  doc_choose_file: 'फाइल निवडा',
  doc_title_field: 'शीर्षक',
  doc_title_ph: 'उदा. AGM 2025-26 मिनिट्स (सही केलेले)',
  doc_uploading: 'अपलोड होत आहे…',
  doc_cat_minutes: 'मिनिट्स',
  doc_cat_legal: 'कायदेशीर',
  doc_cat_certificate: 'सर्टिफिकेट',
  doc_cat_contract: 'कॉन्ट्रॅक्ट',
  doc_cat_circular: 'सर्क्युलर',
  doc_cat_finance: 'वित्त',
  doc_cat_general: 'सामान्य',

  // document viewer
  dv_title: 'कागदपत्र',
  dv_download: 'डाउनलोड',
  dv_download_unavailable: 'डाउनलोड अजून उपलब्ध नाही.',
  dv_preview_soon: 'प्रीव्ह्यू लवकरच येत आहे',
  dv_preview_soon_body: 'ॲपमधील प्रीव्ह्यू अजून तयार नाही — तोपर्यंत सोसायटी ऑफिसमधून डाउनलोड करा.',

  // shared bits
  phatt_photos: 'फोटो',
  phatt_camera: 'कॅमेरा',
  phatt_choose: 'फोटो निवडा',
  phatt_remove: 'फोटो काढा',
  phatt_cam_declined: 'कॅमेराची परवानगी मिळाली नाही.',
  phatt_read_error: 'हा फोटो वाचता आला नाही. दुसरा वापरून पहा.',
  phatt_picker_error: 'फोटो पिकर उघडू शकला नाही.',
  dc_busy: 'बुक',
  up_a11y: 'अपव्होट',

  // relative time (timeAgo)
  time_now: 'आत्ताच',
  time_m: '{n} मिनिटांपूर्वी',
  time_h: '{n} तासांपूर्वी',
  time_d: '{n} दिवसांपूर्वी',
  time_today: 'आज',
  time_yesterday: 'काल',

  // gate pass window labels (list row)
  gp_multi_entry: 'अनेक वेळा एंट्री',
  gp_single_entry: 'एकदा एंट्री',

  // visitor detail
  vd_title: 'भेटीचा तपशील',
  vd_type_guest: 'पाहुणे',
  vd_type_delivery: 'डिलीव्हरी',
  vd_type_cab: 'कॅब',
  vd_type_staff: 'स्टाफ भेट',
  vd_view_photo: 'फोटो पहा',
  vd_no_photo: 'अजून फोटो नाही',
  vd_err_title: 'भेट सापडली नाही',
  vd_err_body: 'ही एंट्री काढून टाकली गेली असावी, किंवा तुम्हाला तिचा ॲक्सेस नाही.',
  vd_back: 'पाहुण्यांकडे परत',
  vd_call: 'कॉल करा',
  vd_call_a11y: '{name} ला कॉल करा',
  vd_expected_from: 'येण्याची वेळ',
  vd_expected_until: 'या वेळेपर्यंत',
  vd_arrived: 'गेटवर पोहोचले',
  vd_checked_in: 'आत आले',
  vd_checked_out: 'बाहेर गेले',
  vd_no_timings: 'या भेटीची कोणतीही गेट वेळ नोंदवलेली नाही.',
  vd_company: 'कंपनी',
  vd_vehicle: 'गाडी',
  vd_id_checked: 'ID तपासले',
  vd_approved_by: 'कोणी मंजुरी दिली',
  vd_no_details: 'गेटवर कोणतीही अतिरिक्त माहिती नोंदवली नाही.',
  vd_notes: 'नोट',
  vd_captured: 'गार्डने एंट्रीवर घेतला.',

  // community issue categories
  ic_cleanliness: 'साफसफाई',
  ic_lift: 'लिफ्ट',
  ic_noise: 'आवाज',
  ic_water: 'पाणी',
  ic_parking: 'पार्किंग',
  ic_electrical: 'वीज',
  ic_garbage: 'कचरा',
  ic_plumbing: 'प्लंबिंग',
  ic_housekeeping: 'हाउसकीपिंग',
  ic_internet: 'इंटरनेट',
  ic_security: 'सुरक्षा',
  ic_maintenance: 'मेंटेनन्स',
  ic_general: 'सामान्य',
  ic_other: 'इतर',

  // discussion tags
  dt_general: 'सामान्य',
  dt_lost_found: 'हरवले-सापडले',
  dt_recommendations: 'शिफारसी',
  dt_help: 'मदत',
  dt_events: 'इव्हेंट',
  dt_announcements: 'घोषणा',
  dt_activities: 'उपक्रम',

  // celebration kind
  ck_birthday: 'वाढदिवस',
  ck_anniversary: 'वर्धापनदिन',

  // notification category
  nc_visitor: 'पाहुणे',
  nc_security: 'सुरक्षा',
  nc_notice: 'सूचना',
  nc_payment: 'पेमेंट',
  nc_booking: 'बुकिंग',
  nc_event: 'इव्हेंट',
  nc_poll: 'पोल',
  nc_community: 'कम्युनिटी',
  nc_system: 'सिस्टम',
  nc_helpdesk: 'हेल्पडेस्क',
  nc_maintenance: 'मेंटेनन्स',

  // date grid weekday letters
  wd_s0: 'र', wd_m: 'सो', wd_t2: 'मं', wd_w: 'बु', wd_t4: 'गु', wd_f: 'शु', wd_s6: 'श',

  // outbound share text
  gp_share_text_link: '{name} साठी Bero गेट पास. गेटवर हे दाखवा:\n{link}',
  gp_share_text_code: '{name} साठी Bero गेट पास — कोड {code}. {valid}.',
  gp_share_title: 'Bero गेट पास',
  pi_share_text: 'तुम्हाला आमंत्रण आहे — {title}! तुमच्या गेट पाससाठी टॅप करा:\n{link}',

  // Gate tab (hub)
  gt_at_gate_now: 'गेटवर आत्ता',
  gt_none_waiting: 'गेटवर कोणीही वाट पाहत नाही',
  gt_none_waiting_sub: 'कोणी आल्यावर तुम्हाला लगेच कळवले जाईल.',
  gt_tap_review: 'पाहण्यासाठी टॅप करा',
  gt_preapprove: 'पाहुण्याला आधीच मंजुरी द्या',
  gt_gate_security: 'गेट आणि सुरक्षा',
  gt_svc_gatepass: 'गेट पास',
  gt_svc_gatepass_sub: 'QR / PIN शेअर करा',
  gt_svc_party: 'पार्टी आमंत्रण',
  gt_svc_party_sub: 'एक लिंक, अनेक पाहुणे',
  gt_svc_message: 'गेटला संदेश',
  gt_svc_message_sub: 'गार्ड डेस्कला नोट',
  gt_svc_history: 'पाहुणे इतिहास',
  gt_svc_history_sub: 'कोण आले-गेले',
  gt_svc_staff: 'घरगुती कर्मचारी',
  gt_svc_staff_sub: 'मोलकरीण, स्वयंपाकी, ड्रायव्हर',
  gt_svc_attendance: 'हजेरी',
  gt_svc_attendance_sub: 'कर्मचारी आत / बाहेर',
  gt_svc_parcels: 'पार्सल',
  gt_svc_parcels_sub: 'गेटवर ठेवलेले',
  gt_svc_delivery_pin: 'डिलिव्हरी PIN',
  gt_svc_delivery_pin_sub: 'ड्रॉप स्वयं-मंजूर',
  gt_svc_family: 'फॅमिली पास',
  gt_svc_family_sub: 'कायमस्वरूपी प्रवेश',
  gt_svc_kids: 'मुले',
  gt_svc_kids_sub: 'नियमित परवानग्या',
  gt_svc_move: 'मूव्ह इन / आउट',
  gt_svc_move_sub: 'स्लॉटची विनंती',

  // Onboarding — shared steps rail
  onb_step_society: 'तुमची सोसायटी शोधा',
  onb_step_society_sub: 'नाव किंवा शहरावरून शोधा',
  onb_step_society_chosen: 'सोसायटी निवडली',
  onb_step_flat: 'तुमचा फ्लॅट निवडा',
  onb_step_flat_sub: 'विंग आणि नंबर',
  onb_step_flat_chosen: 'फ्लॅट निवडला',
  onb_step_verify: 'निवास पडताळा',
  onb_step_verify_sub: 'भूमिका आणि एक कागदपत्र',
  onb_step_account: 'तुमचे खाते तयार करा',
  onb_step_account_sub: 'नाव, ईमेल आणि पासवर्ड',

  // Onboarding — shared bits
  onb_back: 'मागे',
  onb_done: 'झाले',
  onb_choose_society: 'सोसायटी निवडा',
  onb_start_over_title: 'पुन्हा सुरू करा',
  onb_check_connection: 'तुमचे कनेक्शन तपासा आणि पुन्हा प्रयत्न करा.',
  onb_your_society: 'तुमची सोसायटी',
  onb_sign_out: 'साइन आउट',
  onb_foot_note: 'तुमच्या सोसायटी कमिटीकडून पुनरावलोकन केले जाते. Bero जाहिराती दाखवत नाही किंवा डेटा विकत नाही.',

  // Onboarding — society select
  onb_soc_title: 'तुम्ही कोणत्या सोसायटीत राहता?',
  onb_soc_sub_desktop: 'आम्ही त्याच समुदायासाठी तुमचे खाते सेट करू.',
  onb_soc_sub_mobile: 'पायरी 1/3 · आम्ही त्याच समुदायासाठी तुमचे खाते सेट करू.',
  onb_soc_search_ph: 'सोसायटीचे नाव किंवा शहरावरून शोधा',
  onb_results: 'निकाल',
  onb_near_you: 'तुमच्या जवळ',
  onb_soc_cant_find: 'तुमची सोसायटी सापडत नाही?',
  onb_soc_ask_bring: 'तिथे Bero आणण्यास आम्हाला सांगा',
  onb_soc_not_on_bero: 'अजून BERO वर नाही',
  onb_soc_flats: '{count} फ्लॅट',
  onb_soc_err_title: 'सोसायट्या लोड होऊ शकल्या नाहीत',
  onb_soc_none_title: 'कोणतीही सोसायटी सापडली नाही',
  onb_soc_none_body: 'दुसरे नाव वापरून पाहा किंवा स्पेलिंग तपासा.',

  // Onboarding — lead capture
  onb_lead_done_title: 'समजले — आम्ही यावर काम करत आहोत',
  onb_lead_done_body: 'आम्ही {society} मध्ये Bero आणण्याबद्दल तुमच्याशी संपर्क करू. स्पॅम नाही — फक्त एक कॉल.',
  onb_lead_your_society: 'तुमची सोसायटी',
  onb_lead_title: 'तुमच्या सोसायटीत Bero आणा',
  onb_lead_sub: 'तुम्ही कुठे राहता ते सांगा आणि आम्ही तुमच्या कमिटीशी बोलू.',
  onb_lead_society_label: 'सोसायटीचे नाव',
  onb_lead_society_ph: 'उदा. Palm Meadows CHS',
  onb_lead_city_label: 'शहर',
  onb_lead_city_ph: 'उदा. पुणे',
  onb_lead_name_label: 'तुमचे नाव (पर्यायी)',
  onb_lead_name_ph: 'जेणेकरून कोणाला विचारायचे ते आम्हाला कळेल',
  onb_lead_phone_label: 'फोन',
  onb_lead_error: 'आत्ता ते पाठवता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  onb_lead_submit: 'Bero ची विनंती करा',

  // Onboarding — flat select
  onb_flat_no_soc_title: 'आधी सोसायटी निवडा',
  onb_flat_no_soc_body: 'सुरू ठेवण्यासाठी मागे जा आणि तुमची सोसायटी निवडा.',
  onb_wing_n: 'विंग {code}',
  onb_flat_title: 'तुमचा फ्लॅट कोणता?',
  onb_flat_claimed_locked: 'घेतलेले फ्लॅट लॉक आहेत',
  onb_flat_sub_mobile: 'पायरी 2/3 · घेतलेले फ्लॅट लॉक आहेत',
  onb_flat_err_title: 'फ्लॅट लोड होऊ शकले नाहीत',
  onb_flat_none_title: 'कोणताही फ्लॅट सापडला नाही',
  onb_flat_none_body: 'या विंगमध्ये अजून कोणताही फ्लॅट सूचीबद्ध नाही.',
  onb_flat_continue_with: '{code} सह सुरू ठेवा',
  onb_flat_select_cta: 'सुरू ठेवण्यासाठी फ्लॅट निवडा',

  // Onboarding — verify residency
  onb_role_owner: 'मालक',
  onb_role_owner_sub: 'फ्लॅट माझ्या नावावर नोंदणीकृत आहे',
  onb_role_tenant: 'भाडेकरू',
  onb_role_tenant_sub: 'मी हा फ्लॅट भाड्याने घेतला आहे',
  onb_role_family: 'कुटुंबातील सदस्य',
  onb_role_family_sub: 'मी मालक किंवा भाडेकरूसोबत राहतो/राहते',
  onb_verify_title: 'तुम्ही इथे राहता याची पडताळणी करा',
  onb_verify_reviewed: 'तुमच्या कमिटीकडून पुनरावलोकन',
  onb_verify_sub_mobile: 'पायरी 3/3 · तुमच्या कमिटीकडून पुनरावलोकन',
  onb_verify_i_am: 'मी आहे',
  onb_verify_proof: 'निवासाचा पुरावा',
  onb_verify_upload_title: 'करार किंवा वीज बिल अपलोड करा',
  onb_verify_upload_hint: 'PDF किंवा फोटो · कमाल 10 MB',
  onb_verify_upload_unavailable: 'कागदपत्र अपलोड अजून उपलब्ध नाही.',
  onb_verify_encrypt_note: 'तुमची कागदपत्रे एन्क्रिप्टेड आहेत आणि फक्त तुमच्या सोसायटी अ‍ॅडमिनसोबत सामायिक केली जातात. कधीही तिसऱ्या पक्षासोबत नाही.',
  onb_verify_start_over_body: 'सुरू ठेवण्यासाठी तुमची सोसायटी आणि फ्लॅट पुन्हा निवडा.',
  onb_verify_submit: 'मंजुरीसाठी पाठवा',

  // Onboarding — create account
  onb_signup_title: 'तुमचे खाते तयार करा',
  onb_signup_sub: 'शेवटची पायरी — याच द्वारे तुम्ही साइन इन कराल.',
  onb_signup_start_over_body: 'तुमचे खाते तयार करण्यासाठी तुमची सोसायटी पुन्हा निवडा.',
  onb_signup_flat: 'फ्लॅट {code}',
  onb_signup_name_label: 'पूर्ण नाव',
  onb_signup_name_ph: 'उदा. अमित शर्मा',
  onb_signup_email_label: 'ईमेल पत्ता',
  onb_signup_phone_label: 'फोन नंबर',
  onb_signup_phone_help: 'गेटवर तुमच्यापर्यंत पोहोचण्यासाठी याचा वापर करतील.',
  onb_signup_password_label: 'पासवर्ड',
  onb_signup_min8: 'किमान 8 अक्षरे.',
  onb_signup_err_name: 'तुमचे पूर्ण नाव टाका.',
  onb_signup_err_email: 'वैध ईमेल पत्ता टाका.',
  onb_signup_err_phone: 'वैध फोन नंबर टाका.',
  onb_signup_err_email_taken: 'हा ईमेल आधीच नोंदणीकृत आहे.',
  onb_signup_err_society_404: 'ही सोसायटी सापडली नाही. कृपया पुन्हा सुरू करा.',
  onb_signup_err_generic: 'आत्ता तुमचे खाते तयार करता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  onb_signup_submit: 'खाते तयार करा',

  // Onboarding — pending approval
  onb_pending_title: 'गेटवर प्रतीक्षेत',
  onb_pending_body: 'तुमची कमिटी नवीन रहिवाशांचे पुनरावलोकन करते. बहुतेक मंजुऱ्या एका दिवसात होतात. तुम्ही सामील होताच आम्ही तुम्हाला ईमेल करू.',
  onb_pending_badge: 'प्रलंबित',
  onb_pending_submitted: '{when} रोजी पाठवले',
  onb_pending_notify: 'मंजुरी मिळाल्यावर कळवा',

  // polls (index)
  poll_active: 'चालू',
  poll_err_body: 'पोल लोड करताना काहीतरी अडचण आली. तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  poll_empty_closed_title: 'कोणताही बंद पोल नाही',
  poll_empty_closed_body: 'एखादा पोल बंद झाल्यावर निकाल इथे दिसतील.',
  poll_vote_error: 'तुमचे मत नोंदवता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  poll_submit_vote: 'मत पाठवा',

  // events (index)
  event_err_body: 'इव्हेंट लोड करताना काहीतरी अडचण आली. तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  event_empty_upcoming_title: 'कोणताही येणारा इव्हेंट नाही',
  event_empty_upcoming_body: 'कमिटी एखादा इव्हेंट ठरवेल तेव्हा तो इथे दिसेल.',
  event_empty_past_title: 'कोणताही मागील इव्हेंट नाही',
  event_empty_past_body: 'इव्हेंट झाल्यानंतर इथे येतात.',
  event_create: 'इव्हेंट तयार करा',
  event_going: '{n} जाणार',

  // issues (index)
  issue_tab_personal: 'वैयक्तिक',
  issue_err_body: 'तक्रारी लोड करताना काहीतरी अडचण आली. तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  issue_empty_personal_title: 'कोणतीही वैयक्तिक तक्रार नाही',
  issue_empty_personal_body: 'तुमच्या फ्लॅटसाठी केलेल्या तक्रारी इथे दिसतील.',
  issue_upvote_error: 'तुमचे अपव्होट नोंदवता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  issue_report: 'तक्रार नोंदवा',
  issue_notify_wing: 'विंगच्या रहिवाशांना कळवले',
  issue_notify_all: 'सर्व रहिवाशांना कळवले',
  issue_notify_helpdesk: 'हेल्पडेस्कला कळवले',
  issue_notify_wing_x: 'विंग {wing} च्या रहिवाशांना कळवले',
  ev_cat_festival: 'सण',
  ev_cat_sports: 'खेळ',
  ev_cat_kids: 'मुले',
  ev_cat_cultural: 'सांस्कृतिक',
  ev_cat_meeting: 'मीटिंग',
  ev_cat_general: 'सामान्य',

  // vendors (index)
  vendor_title: 'विश्वासू व्हेंडर',
  vendor_cat_electrician: 'इलेक्ट्रिशियन',
  vendor_cat_housekeeping: 'हाउसकीपिंग',
  vendor_cat_appliance: 'उपकरणे',
  vendor_cat_gardening: 'बागकाम',
  vendor_cat_plumbing: 'प्लंबिंग',
  vendor_cat_carpentry: 'सुतारकाम',
  vendor_cat_painting: 'रंगकाम',
  vendor_cat_pest: 'कीड नियंत्रण',
  vendor_err_title: 'व्हेंडर लोड होऊ शकले नाहीत',
  vendor_err_body: 'व्हेंडर लोड करताना काहीतरी अडचण आली. तुमचे इंटरनेट तपासून पुन्हा प्रयत्न करा.',
  vendor_empty_title: 'इथे कोणताही व्हेंडर नाही',
  vendor_empty_body: 'या श्रेणीत रहिवाशांनी सुचवलेले व्हेंडर इथे दिसतील.',
  vendor_pinned: 'पिन केले',
  vendor_endorsement: '{n} रहिवासी शिफारस',
  vendor_endorsements: '{n} रहिवासी शिफारशी',
  vendor_call: '{name} ला कॉल करा',

  // visitors (index)
  vis_title: 'व्हिजिटर',
  vis_filter: 'फिल्टर',
  vis_err_title: 'व्हिजिटर इतिहास उपलब्ध नाही',
  vis_err_body: 'आम्ही सध्या गेट रेकॉर्डपर्यंत पोहोचू शकलो नाही. थोड्या वेळाने पाहा.',
  vis_empty_title: 'अजून कोणताही व्हिजिटर नाही',
  vis_empty_body: 'मंजूर, नाकारलेले आणि आधीच मंजूर व्हिजिटर इथे दिसतील.',
  vis_preapprove: 'व्हिजिटरला आधीच मंजुरी द्या',
  vis_group_earlier: 'त्याआधी',
  vis_load_earlier: 'जुने व्हिजिटर लोड करा',

  // poll (detail)
  poll_detail_title: 'पोल',
  poll_unavailable_title: 'पोल उपलब्ध नाही',
  poll_unavailable_body: 'हा पोल काढून टाकला गेला असावा, किंवा लोड करताना काहीतरी बिघडले.',
  poll_posted_by: '{name} यांनी पोस्ट केले',
  poll_total_votes: 'एकूण {n} मते',
  poll_anon_note: 'उत्तरे निनावी आहेत',

  // event (detail)
  event_detail_title: 'इव्हेंट',
  event_unavailable_title: 'इव्हेंट उपलब्ध नाही',
  event_unavailable_body: 'हा इव्हेंट काढून टाकला गेला असावा, किंवा लोड करताना काहीतरी बिघडले.',
  event_going_residents: '{n} रहिवासी जाणार',
  event_whos_going: 'कोण जाणार',
  event_more: '+{n} आणखी',
  event_rsvp_going: 'जाणार',
  event_rsvp_maybe: 'कदाचित',
  event_rsvp_cant: 'जाऊ शकत नाही',
  event_rsvp_error: 'तुमचे RSVP सेव्ह करता आले नाही. कृपया पुन्हा प्रयत्न करा.',

  // issue (detail)
  issue_detail_title: 'तक्रार',
  issue_unavailable_title: 'तक्रार उपलब्ध नाही',
  issue_comment_error: 'तुमचा कमेंट पोस्ट करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  issue_status_reported: 'नोंदवली',
  issue_status_progress: 'सुरू आहे',
  issue_status_urgent: 'तातडीचे',
  issue_status_resolved: 'निकाली',

  // notice (detail)
  notice_detail_title: 'सूचना',
  notice_unavailable_title: 'सूचना उपलब्ध नाही',
  notice_unavailable_body: 'ही सूचना काढून टाकली गेली असावी, किंवा लोड करताना काहीतरी बिघडले.',
  notice_read_by_one: '{n} रहिवाशाने वाचले',
  notice_read_by_many: '{n} रहिवाशांनी वाचले',
  notice_attachments: 'अटॅचमेंट',
  notice_open: 'उघडा',
  notice_ack_error: 'हे नोंदवता आले नाही. कृपया पुन्हा प्रयत्न करा.',

  // vendor (detail)
  vendor_detail_title: 'व्हेंडर',
  vendor_unavailable_title: 'व्हेंडर उपलब्ध नाही',
  vendor_unavailable_body: 'हा व्हेंडर काढून टाकला गेला असावा, किंवा लोड करताना काहीतरी बिघडले.',
  vendor_endorsements_count: '{n} शिफारशी',
  vendor_endorsed: 'शिफारस केली',
  vendor_endorse: 'शिफारस करा',
  vendor_resident_notes: 'रहिवाशांच्या नोंदी',
  vendor_endorse_error: 'तुमची शिफारस अपडेट होऊ शकली नाही. कृपया पुन्हा प्रयत्न करा.',

  // issues/report (create form)
  ir_title: 'तक्रार नोंदवा',
  ir_discard: 'रद्द करा',
  ir_title_ph: 'उदा. बेसमेंटमध्ये पाइप गळत आहे',
  ir_visibility: 'दृश्यमानता',
  ir_vis_personal: 'वैयक्तिक',
  ir_vis_community: 'समुदाय',
  ir_vis_help_community: 'इतर रहिवासी हे पाहू आणि अपव्होट करू शकतात.',
  ir_vis_help_personal: 'हे फक्त तुम्ही आणि हेल्पडेस्क पाहू शकता.',
  ir_notify: 'कळवा',
  ir_notify_wing: 'माझा विंग',
  ir_notify_all: 'सर्व रहिवासी',
  ir_notify_helpdesk: 'हेल्पडेस्क',
  ir_desc_ph: 'काय बिघडले आहे, आणि कुठे?',
  ir_submit_error: 'सध्या तक्रार नोंदवता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  ir_submit: 'तक्रार नोंदवा',

  // events/create (create form)
  ec_title: 'कार्यक्रम तयार करा',
  ec_discard: 'रद्द करा',
  ec_add_cover: 'कव्हर इमेज जोडा',
  ec_title_label: 'कार्यक्रमाचे नाव',
  ec_title_ph: 'उदा. दिवाळी उत्सव',
  ec_date: 'तारीख',
  ec_date_ph: '9 नोव्हेंबर 2026',
  ec_time: 'वेळ',
  ec_time_ph: '7:00 PM',
  ec_venue: 'ठिकाण',
  ec_venue_ph: 'क्लबहाउस लॉन',
  ec_desc_ph: 'काय होत आहे?',
  ec_submit_error: 'सध्या कार्यक्रम नोंदवता आला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  ec_submit: 'कार्यक्रम नोंदवा',

  // staff (directory + register)
  staff_title: 'माझा स्टाफ आणि मदत',
  staff_register_new: 'नवीन स्टाफ नोंदवा',
  staff_info_note: 'नोंदणीकृत मदतनीस त्यांच्या वैयक्तिक कोडने आत येऊ शकतात. तुम्हाला ये-जा वेळ दिसेल.',
  staff_error_title: 'स्टाफ यादी उपलब्ध नाही',
  staff_error_body: 'सध्या तुमचा स्टाफ लोड होऊ शकला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  staff_section_mine: 'माझा स्टाफ',
  staff_empty_mine: 'अजून तुमच्या फ्लॅटशी कोणताही स्टाफ जोडलेला नाही. खाली जोडा, किंवा + ने नवीन कोणाला नोंदवा.',
  staff_section_directory: 'या सोसायटीत काम करतात',
  staff_directory_hint: 'शेजाऱ्यांनी आधीच नोंदवले आहे — एका टॅपमध्ये तुमच्या फ्लॅटशी जोडा.',
  staff_view_attendance: 'हजेरी लॉग पहा',
  staff_add: 'जोडा',
  staff_adding: 'जोडत आहे…',
  staff_add_error: '{name} ला जोडता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  staff_register_error: 'सध्या त्यांना नोंदवता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  staff_sheet_title: 'घरगुती मदतनीस नोंदवा',
  staff_field_name: 'नाव',
  staff_name_ph: 'उदा. सुनीता बाई',
  staff_field_role: 'भूमिका',
  staff_field_phone: 'फोन (पर्यायी)',
  staff_field_schedule: 'वेळापत्रक (पर्यायी)',
  staff_schedule_ph: 'सोम–शनि · सकाळी 9–11',
  staff_sheet_note: 'त्यांना एक वैयक्तिक गेट कोड मिळतो — गार्ड त्याने त्यांची ये-जा वेळ नोंदवतात.',
  staff_register: 'नोंदवा',
  staff_role_maid: 'मोलकरीण',
  staff_role_cook: 'स्वयंपाकी',
  staff_role_driver: 'ड्रायव्हर',
  staff_role_nanny: 'आया',
  staff_role_presswala: 'प्रेसवाला',
  staff_presence_inside: 'आत',
  staff_presence_left: 'निघून गेले',
  staff_presence_not_in: 'आले नाहीत',

  // staff ID card (detail)
  sid_title: 'स्टाफ आयडी कार्ड',
  sid_more_options: 'अधिक पर्याय',
  sid_error_title: 'स्टाफ तपशील उपलब्ध नाही',
  sid_notfound_title: 'स्टाफ सदस्य सापडला नाही',
  sid_error_body: 'सध्या हे आयडी कार्ड लोड होऊ शकले नाही.',
  sid_badge: 'स्टाफ आयडी',
  sid_id_verified: 'आयडी पडताळली',
  sid_verification_pending: 'पडताळणी बाकी',
  sid_works_for: 'कोणासाठी काम',
  sid_gate_code: 'गेट कोड',
  sid_this_month: 'या महिन्यात',
  sid_days_in_one: '{n} दिवस हजर',
  sid_days_in_many: '{n} दिवस हजर',
  sid_updating: 'अपडेट होत आहे…',
  sid_change_photo: 'फोटो बदला',
  sid_add_photo: 'फोटो जोडा',
  sid_photo_error: 'फोटो अपडेट करता आला नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  sid_no_ratings: 'अजून रेटिंग नाही',
  sid_rating_summary_one: '{avg} · {n} रेटिंग',
  sid_rating_summary_many: '{avg} · {n} रेटिंग',
  sid_you_rated_one: 'तुम्ही {n} स्टार दिला — बदलण्यासाठी टॅप करा',
  sid_you_rated_many: 'तुम्ही {n} स्टार दिले — बदलण्यासाठी टॅप करा',
  sid_rate_prompt: 'तुमच्या फ्लॅटसाठी त्यांच्या कामाला रेट करा',
  sid_record_payment: 'पेमेंट नोंदवा',
  sid_record_payment_sub: 'तुमच्या फ्लॅटसाठी खासगी पगार लॉग ठेवा',
  sid_attendance_summary: 'हजेरी सारांश',
  sid_attendance_summary_sub: 'या सदस्याचा ये-जा लॉग',
  sid_removing: 'काढत आहे…',
  sid_remove_from_flat: 'माझ्या फ्लॅटमधून काढा',
  sid_remove_note: 'ते सोसायटीत नोंदणीकृत राहतात — यामुळे फक्त तुमच्या फ्लॅटशी जोडणी काढली जाते.',
  sid_remove_error: 'त्यांना तुमच्या फ्लॅटमधून काढता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  sid_rate_title: '{name} चे काम कसे आहे?',
  sid_rate_note_label: 'काही जोडायचे आहे? (पर्यायी)',
  sid_rate_note_ph: 'हे फक्त तुमचा सोसायटी अ‍ॅडमिन पाहू शकतो',
  sid_save_rating: 'रेटिंग जतन करा',
  sid_pay_title: 'पेमेंट नोंदवा',
  sid_amount_label: 'रक्कम (₹)',
  sid_note_label: 'टीप (पर्यायी)',
  sid_pay_note_ph: 'जुलैचा पगार, दिवाळी बोनस…',
  sid_record: 'नोंदवा',
  sid_recent: 'अलीकडील',
  sid_entry_remove_error: 'ती नोंद काढता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  sid_pay_error: 'पेमेंट नोंदवता आले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  sid_rating_error: 'रेटिंग जतन करता आली नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.',
  sid_pay_note_footer: 'तुमच्या फ्लॅटपुरते खासगी — एक वैयक्तिक हिशेब, ट्रान्सफर नाही.',

  // forgot-password (fgp_*)
  fgp_title: 'तुमचा पासवर्ड रीसेट करा',
  fgp_subtitle: 'आम्ही तुम्हाला रीसेट लिंक ईमेल करू. मॅजिक-लिंक साइन-इनला कधीही पासवर्डची गरज नसते.',
  fgp_send: 'रीसेट लिंक ईमेल करा',
  fgp_back_to_signin: 'साइन-इनवर परत जा',
  fgp_check_title: 'तुमचा ईमेल पाहा',
  fgp_check_body: '{email} साठी खाते असल्यास, तुम्हाला लवकरच रीसेट लिंक मिळेल.',

  // reset-password (rp_*)
  rp_title: 'नवीन पासवर्ड सेट करा',
  rp_for: '{who} साठी',
  rp_your_account: 'तुमच्या खात्या',
  rp_new_password_label: 'नवीन पासवर्ड',
  rp_confirm_label: 'पासवर्डची पुष्टी करा',
  rp_min: 'किमान 8 अक्षरे, ज्यात एक अंक असावा.',
  rp_mismatch: 'पासवर्ड जुळत नाहीत.',
  rp_save: 'नवीन पासवर्ड जतन करा',
  rp_strength_weak: 'कमकुवत',
  rp_strength_good: 'चांगला',
  rp_strength_strong: 'मजबूत',
  rp_done_title: 'पासवर्ड रीसेट झाला',
  rp_done_body: 'कृपया तुमच्या नवीन पासवर्डने साइन इन करा.',

  // magic-sent (ms_*)
  ms_title: 'तुमचा मेल पाहा',
  ms_body_before: 'आम्ही या पत्त्यावर साइन-इन लिंक पाठवली आहे —',
  ms_body_after: '. याच डिव्हाइसवर ईमेल उघडा आणि पुढे जाण्यासाठी लिंकवर टॅप करा.',
  ms_your_email: 'तुमच्या ईमेल पत्त्या',
  ms_open_mail: 'मेल अ‍ॅप उघडा',
  ms_resend_countdown: 'मिळाली नाही? पुन्हा पाठवा ({secs} सेकंद)',
  ms_resend: 'लिंक पुन्हा पाठवा',

  // login continue
  login_continue: 'पुढे जा',
  // verify-code (vc_*)
  vc_title: 'तुमचा कोड टाका',
  vc_sent_to: 'आम्ही {email} वर 6-अंकी कोड पाठवला आहे. साइन इन करण्यासाठी तो खाली टाका.',
  vc_code_label: '6-अंकी कोड',
  vc_verify: 'पडताळा',
  vc_resend: 'कोड पुन्हा पाठवा',
  vc_resend_in: '{s} सेकंदांत पुन्हा पाठवा',
  vc_err_invalid: 'हा कोड चुकीचा आहे किंवा त्याची मुदत संपली आहे.',
  vc_err_rate: 'खूप वेळा प्रयत्न झाले. कृपया थोडा वेळ थांबून पुन्हा प्रयत्न करा.',
  vc_err_generic: 'काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.',

  // pay/success (ps_*)
  ps_paid_thanks: 'पैसे भरले, धन्यवाद',
  ps_received: 'पेमेंट मिळाले',
  ps_paid_via: 'याद्वारे भरले',
  ps_reference: 'संदर्भ',
  ps_time: 'वेळ',
  ps_receipt: 'पावती',
  ps_download_pdf: 'PDF डाउनलोड करा',
  ps_done: 'पूर्ण झाले',

  // +not-found (nf_*)
  nf_title: 'हे गेट कुठेही जात नाही',
  nf_body: 'तुम्ही शोधत असलेले पान अस्तित्वात नाही, किंवा हलवले असावे.',

  // CompanyPicker (cp_*)
  cp_more: 'आणखी…',
  cp_which_cab: 'कोणती कॅब सेवा?',
  cp_which_company: 'कोणती कंपनी?',
  cp_search_ph: 'कंपन्या शोधा',
  cp_use: '“{q}” वापरा',
  cp_no_companies: 'कंपन्या नाहीत.',

  // meetings — shared/index (mtg_*)
  nav_new: 'नवीन',
  mtg_kind_mc: 'समिती',
  mtg_kind_agm: 'AGM',
  mtg_kind_sgm: 'SGM',
  mtg_status_draft: 'मसुदा',
  mtg_status_noticed: 'सूचित',
  mtg_status_held: 'झाली',
  mtg_status_minutes_due: 'इतिवृत्त बाकी',
  mtg_status_closed: 'बंद',
  mtg_status_cancelled: 'रद्द',
  mtg_title: 'बैठका',
  mtg_forbidden_title: 'फक्त समिती',
  mtg_forbidden_body: 'बैठका समिती व पदाधिकारी चालवतात. तुम्हाला प्रवेश मिळायला हवा असल्यास तुमच्या समितीला विचारा.',
  mtg_err_title: 'बैठका लोड होऊ शकल्या नाहीत',
  mtg_agm_due: 'AGM {days} दिवसांत देय — {date} पर्यंत',
  mtg_agm_overdue: 'AGM {days} दिवस उशिरा',
  mtg_empty_title: 'अजून कोणतीही बैठक नाही',
  mtg_empty_cta: 'बैठक ठरवा',
  mtg_quorum_count: 'कोरम {p}/{r}',
  mtg_not_met: 'पूर्ण नाही',

  // meetings/new (mtn_*)
  mtn_title: 'बैठक ठरवा',
  mtn_err_date: 'तारीख YYYY-MM-DD असावी, उदा. 2026-07-28.',
  mtn_err_time: 'वेळ HH:MM (24ता) असावी, उदा. 18:30.',
  mtn_err_generic: 'बैठक ठरवता आली नाही.',
  mtn_f_title: 'शीर्षक',
  mtn_f_title_help: 'डीफॉल्ट: "{label}"',
  mtn_f_date: 'तारीख',
  mtn_f_time: 'वेळ (24ता)',
  mtn_f_venue: 'ठिकाण',
  mtn_ph_venue: 'सोसायटी कार्यालय',
  mtn_agenda: 'कार्यक्रम पत्रिका',
  mtn_ph_item: 'मुद्दा {n}',
  mtn_a11y_recusal: 'हितसंघर्षामुळे दूर राहणे टॉगल करा',
  mtn_recusal: 'दूर राहणे',
  mtn_remove_item: 'मुद्दा काढा',
  mtn_add_item: '+ मुद्दा जोडा',
  mtn_scheduling: 'ठरवत आहे…',

  // meetings/[id] (mtd_*)
  mtd_title_meeting: 'बैठक',
  mtd_err_load: 'ही बैठक लोड होऊ शकली नाही',
  mtd_notice: 'सूचना',
  mtd_business: 'कामकाज',
  mtd_recusal: 'दूर राहणे',
  mtd_quorum: 'कोरम',
  mtd_required_present: 'आवश्यक: {n} उपस्थित',
  mtd_present_quorum: '{p}/{r} उपस्थित — कोरम {verdict}',
  mtd_met: 'पूर्ण',
  mtd_not_met: 'पूर्ण नाही',
  mtd_certified_by: '{name} यांनी प्रमाणित',
  mtd_the_committee: 'समिती',
  mtd_recorded_suffix: ' · {name} यांनी नोंदवले',
  mtd_minutes: 'इतिवृत्त',
  mtd_not_recorded: 'अजून नोंदवले नाही.',
  mtd_working: 'सुरू आहे…',
  mtd_issue_notice: 'सूचना द्या',
  mtd_ok_notice: 'सूचना जारी केली आणि सदस्यांना कळवले.',
  mtd_mark_held: 'संपन्न म्हणून चिन्हांकित करा',
  mtd_record_minutes: 'इतिवृत्त नोंदवा',
  mtd_edit_minutes: 'इतिवृत्त संपादित करा',
  mtd_certify_meeting: 'बैठक प्रमाणित करा',
  mtd_cancel_meeting: 'बैठक रद्द करा',
  mtd_ok_cancel: 'बैठक रद्द केली.',
  mtd_done: 'झाले.',
  mtd_err_generic: 'ते करता आले नाही.',
  mtd_who_present: 'कोण उपस्थित होते?',
  mtd_quorum_needs: 'कोरमसाठी {total} पैकी {q} समिती सदस्य आवश्यक.',
  mtd_members_present: 'उपस्थित सदस्य',
  mtd_quorum_help: 'कोरम: {n}',
  mtd_ph_headcount: 'उदा. 24',
  mtd_recording: 'नोंदवत आहे…',
  mtd_record_attendance: 'उपस्थिती नोंदवा',
  mtd_ok_attendance: 'उपस्थिती नोंदवली — प्रमाणनासाठी दुसऱ्या सदस्याची प्रतीक्षा.',
  mtd_minutes_of_meeting: 'बैठकीचे इतिवृत्त',
  mtd_ph_minutes: 'घेतलेले निर्णय, मते, पाहिलेली दूर राहणी…',
  mtd_saving: 'जतन करत आहे…',
  mtd_save_minutes: 'इतिवृत्त जतन करा',
  mtd_ok_minutes: 'इतिवृत्त मसुदा म्हणून जतन केले.',
  mtd_certify_the_meeting: 'बैठक प्रमाणित करा',
  mtd_cert_attendance: 'उपस्थिती व कोरम — {p}/{r} उपस्थित, कोरम {verdict}',
  mtd_cert_minutes: 'वर नोंदवलेले इतिवृत्त',
  mtd_certifying: 'प्रमाणित करत आहे…',
  mtd_certify_full: 'उपस्थिती, कोरम व इतिवृत्त प्रमाणित करा',
  mtd_ok_certified: 'बैठक प्रमाणित केली.',

  // elections/index (el_*)
  el_phase_announced: 'घोषित',
  el_phase_nominations: 'नामांकन खुले',
  el_phase_scrutiny: 'छाननी',
  el_phase_voting: 'मतदान',
  el_phase_completed: 'पूर्ण',
  el_phase_cancelled: 'रद्द',
  el_title: 'निवडणुका',
  el_err_title: 'निवडणुका लोड होऊ शकल्या नाहीत',
  el_empty_title: 'अजून कोणतीही निवडणूक नाही',
  el_intro: 'समिती निवडणुका — प्रत्येक सदस्य नामांकन, छाननी व निकाल पाहू शकतो.',
  el_seat_one: '{n} जागा',
  el_seat_other: '{n} जागा',
  el_term: 'कार्यकाळ {t}',
  el_cand_one: '{n} उमेदवार',
  el_cand_other: '{n} उमेदवार',
  el_polls: 'मतदान {d}',

  // elections/new (eln_*)
  eln_title: 'निवडणूक जाहीर करा',
  eln_err_title: 'निवडणुकीला शीर्षक द्या.',
  eln_err_seats: 'जागा 1 ते 50 दरम्यान संख्या असावी.',
  eln_err_date: '{label} YYYY-MM-DD असावी.',
  eln_err_generic: 'निवडणूक जाहीर करता आली नाही.',
  eln_f_title: 'शीर्षक',
  eln_ph_title: 'व्यवस्थापन समिती 2026–2031',
  eln_f_seats: 'जागा',
  eln_ph_seats: 'उदा. 5',
  eln_f_term: 'कार्यकाळ',
  eln_f_reserved: 'राखीव जागा',
  eln_f_nomclose: 'नामांकन समाप्ती',
  eln_f_votedate: 'मतदान तारीख',
  eln_announcing: 'जाहीर करत आहे…',

  // elections/[id] (eld_*)
  eld_adv_announced: 'नामांकन सुरू करा',
  eld_adv_nominations: 'नामांकन बंद करा — छाननी सुरू करा',
  eld_adv_scrutiny: 'मतदान सुरू करा',
  eld_title: 'निवडणूक',
  eld_err_load: 'ही निवडणूक लोड होऊ शकली नाही',
  eld_seat_one: '{n} जागा',
  eld_seat_other: '{n} जागा',
  eld_term: 'कार्यकाळ {t}',
  eld_nom_close: 'नामांकन समाप्ती {d}',
  eld_polls: 'मतदान {d}',
  eld_stand: 'निवडणूक लढा',
  eld_nom_in: 'तुमचे नामांकन झाले — पुढे छाननी होईल.',
  eld_ballot_in: 'तुमचे मत नोंदले. निकाल जाहीर झाल्यावर दिसतील.',
  eld_results: 'निकाल',
  eld_candidates: 'उमेदवार · {n}',
  eld_no_noms: 'अजून कोणतेही नामांकन नाही.',
  eld_member: 'सदस्य',
  eld_proposed_by: '{name} यांनी सुचवले',
  eld_pill_elected: 'निवडून आले',
  eld_pill_rejected: 'नाकारले',
  eld_pill_on_ballot: 'मतपत्रिकेवर',
  eld_pill_pending: 'प्रलंबित',
  eld_vote_one: '{n} मत',
  eld_vote_other: '{n} मते',
  eld_flagged: 'चिन्हांकित: {note}',
  eld_accept: 'स्वीकारा',
  eld_ok_accepted: '{name} मतपत्रिकेवर आहेत.',
  eld_reject: 'नाकारा',
  eld_ok_rejected: '{name} छाननीत नाकारले.',
  eld_vote_for: '{name} यांना मत द्या',
  eld_working: 'सुरू आहे…',
  eld_ok_advanced: 'टप्पा पुढे नेला.',
  eld_declare: 'निकाल जाहीर करा',
  eld_ok_declared: 'निकाल जाहीर.',
  eld_constitute: 'समिती स्थापन करा',
  eld_ok_constituted: 'विजेते समिती सदस्य पदावर जोडले.',
  eld_cancel_election: 'निवडणूक रद्द करा',
  eld_ok_cancelled: 'निवडणूक रद्द केली.',
  eld_f_statement: 'निवेदन',
  eld_f_statement_help: 'ऐच्छिक — सदस्यांनी तुम्हाला मत का द्यावे',
  eld_ph_statement: 'सोसायटीसाठी तुम्ही कशावर लक्ष द्याल',
  eld_submitting: 'सबमिट करत आहे…',
  eld_submit_nom: 'नामांकन सबमिट करा',
  eld_ok_nom: 'नामांकन सबमिट केले.',
  eld_cast_ballot: 'तुमचे मत द्या',
  eld_vote_confirm: '{name} यांना मत द्यायचे?',
  eld_ballot_rules: 'प्रति सदस्य एकच मत; ते बदलता येत नाही. निकाल जाहीर होईपर्यंत मोजणी सीलबंद राहते.',
  eld_casting: 'देत आहे…',
  eld_cast_btn: 'मत द्या',
  eld_ok_ballot: 'मत दिले.',
  eld_recording: 'नोंदवत आहे…',
  eld_record_result: 'निकाल नोंदवा',
  eld_ok_recorded: 'निकाल नोंदवले.',
  eld_err_generic: 'ते करता आले नाही.',

  // finances (fin_*)
  fin_cat_maintenance: 'देखभाल',
  fin_cat_repairs: 'दुरुस्ती',
  fin_cat_security: 'सुरक्षा',
  fin_cat_utilities: 'सुविधा',
  fin_cat_housekeeping: 'स्वच्छता',
  fin_cat_events: 'कार्यक्रम',
  fin_cat_admin: 'प्रशासन',
  fin_cat_other: 'इतर',
  fin_err_amount: 'रक्कम रुपयांत टाका.',
  fin_err_note: 'खर्च कशासाठी होता ते सांगा.',
  fin_err_date: 'तारीख YYYY-MM-DD असावी.',
  fin_ok_recorded: '{amount} {cat} अंतर्गत नोंदवले.',
  fin_err_record: 'खर्च नोंदवता आला नाही.',
  fin_ok_voided: '{amount} ची नोंद रद्द — ऑडिट ट्रेलवर नोंदवली.',
  fin_err_void: 'रद्द करता आले नाही.',
  fin_err_receipt: 'पावती उघडता आली नाही.',
  fin_title: 'सोसायटी वित्त',
  fin_expense_btn: 'खर्च',
  fin_err_load: 'वित्त लोड होऊ शकले नाही',
  fin_intro: 'सोसायटीत येणारा व जाणारा प्रत्येक रुपया, महिन्या-महिन्याने. पावत्या खजिनदार नोंदवतात; खर्च पावत्यांसह ऑडिट ट्रेलवर येतात.',
  fin_monthly_statement: 'मासिक विवरण',
  fin_collected: 'जमा',
  fin_spent: 'खर्च',
  fin_ledger_title: 'खर्च वही · समिती दृश्य',
  fin_no_expenses: 'अजून कोणताही खर्च नोंदवला नाही.',
  fin_receipt: 'पावती',
  fin_void: 'रद्द',
  fin_record_expense: 'खर्च नोंदवा',
  fin_f_amount: 'रक्कम (₹)',
  fin_ph_amount: 'उदा. 4200',
  fin_f_date: 'तारीख',
  fin_f_date_help: 'रिकामे = आज',
  fin_f_what: 'कशासाठी?',
  fin_ph_what: 'उदा. लिफ्ट AMC — Q2 बिल',
  fin_f_receipt: 'पावती फोटो',
  fin_f_receipt_help: 'ऐच्छिक — चांगला हिशोब',
  fin_recording: 'नोंदवत आहे…',
  fin_record_expense_btn: 'खर्च नोंदवा',

  // ---- marketing homepage (app/index.tsx) ----
  mkt_nav_gate: 'गेट सुरक्षा',
  mkt_nav_community: 'कम्युनिटी',
  mkt_nav_payments: 'पेमेंट',
  mkt_nav_pricing: 'किंमत',
  mkt_open_app: 'अ‍ॅप उघडा →',
  mkt_request_demo: 'डेमोची विनंती करा',
  mkt_see_how: 'हे कसे काम करते ते पाहा',
  mkt_hero_title: 'तुमच्या सोसायटीचं प्रत्येक गेट, एका शांत अ‍ॅपमध्ये.',
  mkt_hero_sub: 'Bero गोंगाटी गेट अ‍ॅप्सची जागा घेतं. भारतीय हाउसिंग सोसायट्यांसाठी व्हिजिटर, नोटिस, पेमेंट आणि बुकिंग — कोणतीही जाहिरात नाही, कधीच नाही.',
  mkt_f_gate_title: 'कुठूनही, एका टॅपमध्ये व्हिजिटरना मंजुरी द्या.',
  mkt_f_gate_body: 'गार्ड गेटवर फोटो आणि नंबर प्लेट घेतात; रहिवाशांना काउंटडाउनसह पूर्ण स्क्रीनवर मंजुरी मिळते. आधीच मंजूर पाहुणे QR पास किंवा 4-अंकी PIN ने आत येतात.',
  mkt_f_gate_p1: 'पूर्ण स्क्रीनवर मंजुरी',
  mkt_f_gate_p2: 'तिकिटासारखे QR + PIN गेट पास',
  mkt_f_gate_p3: 'पंच इन/आउटसह स्टाफ हजेरी',
  mkt_f_gate_mock: 'तुमच्या गेटवर',
  mkt_f_comm_title: 'लोक खरंच वाचतील असे नोटिस.',
  mkt_f_comm_body: 'तातडीच्या नोटिससाठी पोच आवश्यक असते, पोल स्वच्छ निकालांसह बंद होतात, आणि इव्हेंट फ्लॅटनुसार RSVP गोळा करतात. प्रत्येकजण पडताळलेला शेजारी असल्याने चर्चा सभ्य राहतात.',
  mkt_f_comm_p1: 'फ्लॅटनुसार पोच ट्रॅकिंग',
  mkt_f_comm_p2: 'एक फ्लॅट, एक मत असे पोल',
  mkt_f_comm_p3: 'फक्त पडताळलेले रहिवासी',
  mkt_f_pay_title: 'मेंटेनन्स वेळेवर, वारंवार आठवण न देता.',
  mkt_f_pay_body: 'लाइन-आयटम तपशीलासह स्वच्छ इनव्हॉइस, दोन टॅपमध्ये UPI, त्वरित पावती, आणि नेमकं कोणी भरलं हे दाखवणारा कमिटी डॅशबोर्ड — त्यामुळे आठवण मृदू आणि क्वचित होते.',
  mkt_f_pay_p1: 'UPI, कार्ड आणि ऑटो-पे',
  mkt_f_pay_p2: 'त्वरित PDF पावती',
  mkt_f_pay_p3: 'कमिटी कलेक्शन डॅशबोर्ड',
  mkt_f_pay_mock: 'जुलै मेंटेनन्स',
  mkt_m_delivery_waiting: 'डिलिव्हरी · वाट पाहत',
  mkt_m_guest_pass: 'गेस्ट पास {code}',
  mkt_m_housekeeping: 'हाउसकीपिंग · ड्युटीवर',
  mkt_m_urgent_notice: 'तातडीचा नोटिस',
  mkt_m_poll_voted: 'पोल · {n} नी मत दिलं',
  mkt_m_maint_sinking: 'मेंटेनन्स + सिंकिंग फंड',
  mkt_m_paid_via: '{date} रोजी भरलं · UPI',
  mkt_m_collections: 'कलेक्शन {pct}',
  mkt_m_of_flats: '{b} पैकी {a} फ्लॅट',
  mkt_allow: 'परवानगी द्या',
  mkt_valid: 'वैध',
  mkt_rsvp: 'RSVP',
  mkt_pay: 'भरा',
  mkt_paid: 'भरलं',
  mkt_live: 'लाइव्ह',
  mkt_manifesto_title: 'तुमची सोसायटी हे घर आहे, प्रेक्षक नाही.',
  mkt_manifesto_body: 'जाहिराती नाहीत. प्रायोजित बॅनर नाहीत. "तुमच्या जवळचे ऑफर" नाहीत. तुमचा डेटा दलालांना विकणं नाही. Bero चा खर्च सोसायट्या उचलतात, म्हणून रहिवासी हे ग्राहक आहेत — कधीही उत्पादन नाही.',
  mkt_stat_ads: 'दाखवलेल्या जाहिराती',
  mkt_stat_brokers: 'डेटा दलाल',
  mkt_stat_funded: 'सोसायटी-निधीतून',
  mkt_pricing_kicker: 'सोपी किंमत',
  mkt_pricing_per: 'प्रति फ्लॅट / महिना',
  mkt_pricing_body: 'सर्व काही समाविष्ट — गेट, कम्युनिटी, पेमेंट, गार्ड कियोस्क. कोणतेही टियर नाही, लॉक-इन नाही.',
  mkt_pp1: 'अमर्याद रहिवासी, गार्ड आणि अ‍ॅडमिन',
  mkt_pp2: 'गार्ड टॅबलेट कियोस्क समाविष्ट',
  mkt_pp3: 'हिंदी, मराठी आणि इंग्रजी',
  mkt_pp4: 'डेटा भारतातच राहतो, कधीही विकला जात नाही',
  mkt_demo_title: 'तुमच्याच गेटवर Bero पाहा.',
  mkt_demo_body: 'तुमच्या कमिटीसोबत 30-मिनिटांचा वॉकथ्रू. आम्ही तुमच्या विंग आणि फ्लॅटसह सँडबॉक्स सेट करतो.',
  mkt_link_privacy: 'प्रायव्हसी',
  mkt_link_terms: 'अटी',
  mkt_link_contact: 'संपर्क',
  mkt_footer_copy: '© 2026 Bero Technologies Pvt Ltd, Mumbai',

  // ---- public gate-pass page (app/p/[code].tsx) ----
  pp_loading: 'पास लोड होत आहे…',
  pp_invalid_title: 'हा पास लिंक अवैध आहे',
  pp_invalid_body: 'तो कालबाह्य झाला असेल किंवा रद्द केला असेल. तुमच्या होस्टकडून नवीन लिंक मागा.',
  pp_or_tell_guard: 'किंवा गार्डला सांगा',
  pp_visiting: 'भेटायला आले',
  pp_valid_label: 'वैध',
  pp_daily: 'दररोज',
  pp_footer: 'हे गेटवर दाखवा. गार्ड ते आपोआप तपासतात — कोणत्याही अ‍ॅपची गरज नाही.',
  pp_status_active: 'सक्रिय',
  pp_status_upcoming: 'आगामी',
  pp_status_expired: 'कालबाह्य',
  pp_status_cancelled: 'रद्द',
  pp_multi_entry: 'अनेक वेळा प्रवेश',
  pp_single_entry: 'एकदा प्रवेश',
  pp_valid_until: '{time} पर्यंत वैध',

  // ---- public party-invite page (app/i/[code].tsx) ----
  pi2_loading: 'आमंत्रण लोड होत आहे…',
  pi2_invalid_title: 'हा आमंत्रण लिंक अवैध आहे',
  pi2_invalid_body: 'तो रद्द केला असेल. तुमच्या होस्टकडून नवीन लिंक मागा.',
  pi2_society_invite: '{society} · आमंत्रण',
  pi2_claim_prompt: 'तुमचा गेट पास मिळवण्यासाठी तुमचं नाव लिहा{extra}.',
  pi2_n_left: ' — {n} शिल्लक',
  pi2_name_ph: 'तुमचं नाव',
  pi2_get_pass: 'माझा गेट पास मिळवा',
  pi2_getting: 'तुमचा पास मिळवत आहे…',
  pi2_closed_full: 'या आमंत्रणाचे सर्व गेस्ट पास घेतले गेले आहेत. थेट तुमच्या होस्टला विचारा.',
  pi2_closed_expired: 'हे आमंत्रण कालबाह्य झालं आहे. तुमच्या होस्टकडून नवीन लिंक मागा.',
  pi2_closed_cancelled: 'होस्टने हे आमंत्रण रद्द केलं.',
  pi2_err_generic: 'तुमचा पास मिळू शकला नाही. पुन्हा प्रयत्न करा.',
  pi2_err_network: 'तुमचा पास मिळू शकला नाही. तुमचं कनेक्शन तपासा आणि पुन्हा प्रयत्न करा.',
  pi2_footer: 'तुमच्या पासमध्ये एक QR आणि एक PIN आहे — गेटवर कोणतंही एक दाखवा. कोणत्याही अ‍ॅपची गरज नाही.',
  // desktop sidebar nav
  nav_profile: 'प्रोफाइल',
  nav_vendors: 'वेंडर',
  nav_classifieds: 'क्लासिफाइड',
  nav_lost_found: 'हरवले-सापडले',
  nav_birthdays: 'सोहळे',
  nav_elections: 'निवडणुका',
  nav_preapprove: 'पाहुणा पूर्व-मंजुरी',
  nav_gate_pass: 'गेट पास',
  nav_visitor_history: 'पाहुणे इतिहास',
  nav_household_staff: 'घरगुती कर्मचारी',
  nav_parcels: 'पार्सल',
  nav_vehicles: 'वाहने',
  nav_helpdesk: 'हेल्पडेस्क',
  nav_amenities: 'सुविधा',
  nav_venue_booking: 'ठिकाण बुकिंग',
  nav_my_bookings: 'माझी बुकिंग',
  nav_documents: 'कागदपत्रे',
  nav_residents: 'रहिवासी',
  nav_grp_management: 'व्यवस्थापन',
  nav_society_admin: 'सोसायटी अ‍ॅडमिन',
  nav_committee_desk: 'समिती डेस्क',
  nav_grp_living: 'राहणीमान',
  nav_signed_in: 'साइन इन',
  // status pills
  pill_open: 'खुले',
  pill_progress: 'प्रगतीपथावर',
  pill_urgent: 'तातडीचे',
  pill_resolved: 'निकाली',
  pill_approved: 'मंजूर',
  pill_pending: 'प्रलंबित',
  pill_rejected: 'नाकारले',
  pill_awaiting: 'प्रतीक्षेत',
  pill_at_gate: 'गेटवर',
  pill_left: 'रवाना',
  pill_inside: 'आत',
  pill_reported: 'नोंदवले',
  pill_picked_up: 'घेतले',
  pill_primary: 'प्राथमिक',
  pill_lost: 'हरवले',
  pill_found: 'सापडले',
  pill_event: 'कार्यक्रम',
  pill_committee: 'समिती',
  pill_general: 'सामान्य',
  pill_cancelled: 'रद्द',
  pill_ended: 'संपले',
  pill_full: 'भरले',
  pill_active_now: 'आता सक्रिय',
  pill_upcoming: 'आगामी',
  pill_expired: 'मुदत संपली',
  gp_pass_id: 'पास आयडी',
  home_maint_due: 'देय मेंटेनन्स',
  home_nothing_due: 'आत्ता काहीही देय नाही.',
  home_pay_maint: 'मेंटेनन्स भरा',
  home_community_empty: 'कम्युनिटीकडून नवीन काही नाही.',
  svc_booked: 'बुक झाले',
};
